let allSubscriptions = []; // Stores All logged in customer subscriptions from recharge response including Active and In-Active Subscriptions
let activeSubscriptions = []; // Stores Active Subscriptions
let inActiveSubscriptions = []; // Stores In-Active Subscriptions
let productsJson = {}; // Stored Store front all products JSON
let graphQLProductsJSON = null; // Stores GraphQL Products JSON which are used for displaying image
let customerAddresses = null; // Stored Recharge All Customer Addresses
let customerPaymentMethods = null; // Stores Customer Payment Methods
let subscriptionData = {}; // Stores Specific Subscription Data when any modal is opened
let successModalType = null; // Used for confirmation modal open when any success full action is triggered
let selectedProduct = ""; // Used for storing shopify product information ( Ex. whenever product is changed in updating subscription  )
let selectedVariant = ""; // Used For storing shopify variant information ( Ex. whenever variant is changed in updating subscription   )
let selectedAddonVariant = ""; // Used For storing shopify variant information ( Ex. whenever variant is changed in updating subscription   )
let storeCancellationReason = []; // Stored cancellation reason which are stored in recharge admin
let subscriptionId = "";
let currentAddon = ""; //Used when update addon is triggered
let subscriptionAddressId = "";
let deliverySchedules = null; // Stores delivery schedule of the customer
let selectedAddons = []; //arrays of addons connected with selected subscription
let scheduleDeliveryFlag = false; //flag for scheduled delivery after any update is done.
let customerAddressId = null; // Stores address id to update
let addressIdForAddon = ""; // Stores address id, in order to pass while creating addon obj
let discounts = [];
let selectedProductOptions = [];
let allCharges = [];

let modalType = null;
let paymentData = [];
let is_proProductExist = false;
let is_liteProductExist = false;
let is_platecrateProductExist = false;
let is_monthlyActiveExist = false;
let resumeDate = null;
let isResume = false;
let isProOpen = false;
let paymentMethodId = null;

let swapSubscription = {};
let swapBannerData = window.accountSwapBannerSettings;
let plateCrateSwapBannerData = window.accountPlateCrateSwapBannerSettings;


let cfmFrequencyObject = {};
let cfmShippingFrequency = null;

let upgradeDowngradeObject = {};
let selectedUDMOption = "";

const subscriptionTypes ={
  "platecrate-pro":"Plate Crate Pro",
  "platecrate-lite":"Plate Crate Lite",
  "platecrate":"Plate Crate"
}

class dashboard extends HTMLElement {
  constructor() {
    super();
    this.dashboard = this;

    // Get OnLoad Details With Customers
    if (window.reachargeLoaded) {
      this.getLoadDetails();
    } else {
      const interval = setInterval(() => {
        if (window.reachargeLoaded) {
          clearInterval(interval);
          this.getLoadDetails();
        }
      }, 100);
      setTimeout(() => clearInterval(interval), 10000);
    }
    // Bind enter key event on label
    document.addEventListener("keyup", (event) => {
      if (event.target.closest('[role="button"]')) {
        if (event.keyCode === 13) {
          event.preventDefault();
          event.target.click();
          event.target.focus();
        }
      }
    });

    //check payments detials
    document.querySelectorAll("[data-pay-frequency]").forEach((ele) => {
      ele.addEventListener("click", (event) => {
        this._checkSubPayDetials(event);
      });
    });

    document
      .querySelector(".snotify-icon-error")
      .addEventListener("click", (evnet) => {
        document.querySelector(".snotifyToast__close").click();
      });

    if (document.querySelector("[data-promocode]") != null) {
      document
        .querySelector("[data-promocode]")
        .addEventListener("keyup", (event) => {
          let inputVal = event.currentTarget.value;
          let inputValLen = inputVal.trim().length;
          if (inputValLen === 0) {
            document
              .querySelector("[data-apply_promocode]")
              .classList.add("disabled");
          } else {
            document
              .querySelector("[data-apply_promocode]")
              .classList.remove("disabled");
          }
        });
    }

    //Bind Apply Discount button
    if (document.querySelector("[data-apply_promocode]") != null) {
      document
        .querySelector("[data-apply_promocode]")
        .addEventListener("click", (event) => {
          event.preventDefault();
          this._applyDiscount(event);
        });
    }

    //swap subscription or upgrade
    document.querySelectorAll("[data-swap_subscription_btn]").forEach((ele) => {
      ele.addEventListener("click", (event) => {
        this.swapCurrentSubscription(event);
      });
    });

    // update frequency
    document
      .getElementById("cfm-save-changes-btn")
      ?.addEventListener("click", this.updateSubscriptionFrequency);

    // Upgrage downgrade handler
    document
      .getElementById("udmSaveChangesBtn")
      ?.addEventListener("click", (evt) =>
        this.updateDowngradeSubscription(evt)
      );

    document.querySelectorAll("[data-pause-checkbox]").forEach((ele) => {
      ele.addEventListener("change", () => {
        if (ele.checked) {
          document
            .querySelectorAll("[data-update_charge_date]")
            .forEach((ele) => {
              ele.classList.remove("d-none");
            });
        }
      });
    });

    document.querySelectorAll("[data-pay-checkobox]").forEach((ele) => {
      ele.addEventListener("change", () => {
        if (ele.checked) {
          document
            .querySelectorAll("[data-swap_subscription_btn]")
            .forEach((ele) => {
              ele.classList.remove("d-none");
            });
        }
      });
    });

    document.querySelectorAll("[data-shipping_address]").forEach((ele) => {
      ele.addEventListener("focus", () => {
        document
          .querySelectorAll("[data-update_shipping_address]")
          .forEach((ele) => {
            ele.classList.remove("d-none");
          });
      });
    });

    if (document.querySelectorAll("#SelectDate").length > 0) {
      document
        .querySelector("#SelectDate")
        .addEventListener("change", (event) => {
          this.checkSelectedDate(event);
        });
    }

    document.querySelectorAll("[data-resume-btn]").forEach((ele) => {
      ele.addEventListener("click", (event) => {
        this._resumeSubscription(event);
      });
    });

    // Adding event listerns to change frequency radio buttons
    this._addEventListernToCFMPopupButtons();
    document.getElementById("udm-opener-btn")?.addEventListener("click", () => {
      this._resetUpgradeDowngradePopupDisplay();
    });

    this._initResumeFlatpickrIfNeeded();
  }

  /** Resume field: text input + window.flatpickr (UMD). Also runs after onLoadData. */
  _initResumeFlatpickrIfNeeded() {
    const fpFactory = window.flatpickr;
    if (typeof fpFactory !== "function") {
      return;
    }
    const el = document.getElementById("SelectDate");
    if (!el) {
      return;
    }
    const minM = this._getMinResumeDateMoment();
    const minDate = minM.isValid() ? minM.toDate() : new Date();

    if (el._flatpickr) {
      this._resumeFlatpickr = el._flatpickr;
      try {
        this._resumeFlatpickr.set("minDate", minDate);
      } catch (e) {
        console.warn("resume flatpickr set minDate", e);
      }
      return;
    }

    this._resumeFlatpickr = fpFactory(el, {
      enableTime: false,
      dateFormat: "Y-m-d",
      minDate: minDate,
      allowInput: false,
      clickOpens: true,
      disableMobile: true,
      onOpen: function (_d, _s, instance) {
        if (instance.calendarContainer) {
          instance.calendarContainer.style.zIndex = "2147483646";
        }
      },
      onChange: function (_d, _s, instance) {
        instance.input.dispatchEvent(new Event("change", { bubbles: true }));
      },
    });
  }

  /**
   * Earliest allowed resume date: not before today and not before the subscription's
   * next scheduled charge (Recharge rejects earlier next_charge_scheduled_at).
   */
  _getMinResumeDateMoment() {
    const today = moment().startOf("day");
    if (!subscriptionData || !subscriptionData.next_charge_scheduled_at) {
      return today;
    }
    const scheduled = moment(subscriptionData.next_charge_scheduled_at).startOf(
      "day"
    );
    if (!scheduled.isValid()) {
      return today;
    }
    return moment.max(scheduled, today);
  }

  /** Clear Flatpickr + resumeDate when opening resume for another subscription. */
  _resetResumeDatePickerState() {
    resumeDate = null;
    const el = document.getElementById("SelectDate");
    if (!el) {
      return;
    }
    if (el._flatpickr) {
      el._flatpickr.clear();
    } else {
      el.value = "";
    }
    document.querySelectorAll("[data-resume-btn]").forEach((btn) => {
      btn.classList.add("d-none");
    });
  }

  /** Apply min resume date (today vs next_charge_scheduled_at). */
  _applyResumeDateConstraints() {
    const selectEl = document.querySelector("#SelectDate");
    if (!selectEl) return;
    this._initResumeFlatpickrIfNeeded();
    const fp = this._resumeFlatpickr || selectEl._flatpickr;
    const minM = this._getMinResumeDateMoment();
    if (!minM.isValid()) {
      return;
    }
    if (fp) {
      try {
        fp.set("minDate", minM.toDate());
        const sel = fp.selectedDates[0];
        if (sel && moment(sel).startOf("day").isBefore(minM)) {
          fp.clear();
          resumeDate = null;
          document.querySelectorAll("[data-resume-btn]").forEach((btn) => {
            btn.classList.add("d-none");
          });
        }
      } catch (e) {
        console.warn("resume flatpickr minDate", e);
      }
    } else if (
      selectEl.value &&
      moment(selectEl.value, "YYYY-MM-DD", true).isValid() &&
      moment(selectEl.value).startOf("day").isBefore(minM)
    ) {
      selectEl.value = "";
      resumeDate = null;
      document.querySelectorAll("[data-resume-btn]").forEach((btn) => {
        btn.classList.add("d-none");
      });
    }
  }

  _checkSubPayDetials(event) {
    let currentEle = event.currentTarget;
    let payFrequency = parseInt(currentEle.getAttribute("data-pay-frequency"));
    let shipFrequency = parseInt(
      currentEle.getAttribute("data-ship-frequency")
    );
    let productType = currentEle.getAttribute("data-product-type");
    let mainProductData = JSON.parse(
      currentEle.querySelector("[data-main-product-variant]").innerText
    );

    mainProductData = mainProductData.find(
      (x) => x.variant_title == subscriptionData.variant_title
    );
    let variantId = parseInt(mainProductData.subscription_varint_id);

    swapSubscription = {
      payFrequency: payFrequency,
      shipFrequency: shipFrequency,
      productType: productType,
      variantId: variantId,
    };
  }

  checkSelectedDate(event) {
    let ele = event.currentTarget;
    if (ele.value != "") {
      const minM = this._getMinResumeDateMoment();
      const picked = moment(ele.value).startOf("day");
      if (picked.isBefore(minM)) {
        sdk.notification(
          "Invalid date",
          `Choose a date on or after ${minM.format("MMMM D, YYYY")}.`,
          "error"
        );
        if (ele._flatpickr) {
          ele._flatpickr.clear();
        } else {
          ele.value = "";
        }
        resumeDate = null;
        document.querySelectorAll("[data-resume-btn]").forEach((btn) => {
          btn.classList.add("d-none");
        });
        return;
      }
      resumeDate = ele.value;
      document.querySelectorAll("[data-resume-btn]").forEach((btn) => {
        btn.classList.remove("d-none");
      });
    } else {
      document.querySelectorAll("[data-resume-btn]").forEach((btn) => {
        btn.classList.add("d-none");
      });
    }
  }

  async swapCurrentSubscription(event) {
    let currentTarget = event.currentTarget;
    currentTarget.classList.add("loading");
    let flag = false;

    for (let item of subscriptionData.properties) {
      if (item["name"] === "product_type") {
        item["value"] = swapSubscription.productType;
        flag = true;
      }
    }
    if (flag == false) {
      let subscriptionproperty = {
        name: "product_type",
        value: swapSubscription.productType,
      };
      subscriptionData.properties.push(subscriptionproperty);
    }

    let subsDataObj = {
      address_id: subscriptionData.address_id,
      next_charge_scheduled_at: subscriptionData.next_charge_scheduled_at,
      charge_interval_frequency: swapSubscription.payFrequency,
      order_interval_frequency: swapSubscription.shipFrequency,
      order_interval_unit: subscriptionData.order_interval_unit,
      external_variant_id: {
        ecommerce: `${swapSubscription.variantId.toString()}`,
      },
      quantity: subscriptionData.quantity,
      properties: subscriptionData.properties,
    };
    let response = await sdk._createSubscriptionProduct(subsDataObj);
   
    if(!response) return;

    await this._deleteCurrentSubscription();
    document.querySelector("[data-swap-text]").innerHTML = `
        Your subscription plan has been updated. Your next subscription payment will be on <b>${
          response.next_charge_scheduled_at != null
            ? moment(response.next_charge_scheduled_at).format("MMMM DD, YYYY")
            : this._checkChargeError(response)
        }</b> and renews every ${
      response.charge_interval_frequency
    } months for <b>$${response.price}</b>.
        `;
    if (isProOpen == true) {
      gtag("event", "PlateCrate_pro_upgrade", {
        email: customerDetails.email,
      });
      successModalType = "pro_upgraded";
      let totalCrate =
        response.charge_interval_frequency / response.order_interval_frequency;
      if (totalCrate == 1) {
        totalCrate = `${totalCrate} crate`;
      } else {
        totalCrate = `${totalCrate} crates`;
      }
      let chargeFre = response.charge_interval_frequency;
      if (chargeFre == 1) {
        chargeFre = `${chargeFre} month`;
      } else {
        chargeFre = `${chargeFre} months`;
      }
      let price = response.price.replace(".00", "");
      price = `$${price}`;
      document.querySelector(
        "[upgrade_pro_text]"
      ).innerHTML = `Your card will prepay for ${totalCrate} and will be billed <b> ${price} </b> in ${chargeFre}  again. You can pause, skip or cancel anytime in between.`;
    } else {
      successModalType = "swap";
      gtag("event", "Swap_subscription", {
        email: customerDetails.email,
      });
    }
    await this.onLoadData();
  }
  close_modals() {
    document.querySelectorAll(".modal.recharge-modal.open").forEach((ele) => {
      ele.classList.remove("open");
    });
  }
  _deleteCurrentSubscription() {
    let data = {
      subscription_id: subscriptionData.id,
    };
    const response = fetch(`/tools/platecrate-custom-api/delete-subscription`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        return response;
      });

    return response;
  }

  async getLoadDetails() {
    //Get Customer Details
    await sdk._getCustomerDetails();
    await sdk._getCustomerPortal();
    await this.onLoadData();
  }

  async deliveryDetails() {
    //Get Delivery Schedule
    await sdk._getDeliverySchedule();
    //create Delivery Schedule HTML
    await this._createDeliveryScheduleHTML();
  }

  _bindDeliveryScheduleEvents() {
    // Bind click event for Skip/Unskip in delivery schedule
    document.querySelectorAll("[data-skip_unskip_delivery]").forEach((ele) => {
      ele.addEventListener("click", (event) => {
        event.stopImmediatePropagation();
        this._skipUnskipCharge(event.target);
      });
    });
  }

  async onLoadData() {
    is_proProductExist = false;
    is_liteProductExist = false;
    is_platecrateProductExist = false;
    if (window.customerDetails.rechargeCustomerDetails) {
      //Get Subscriptions
      await sdk._getSubscriptions();

      if (activeSubscriptions.length == 1) {
        subscriptionData = activeSubscriptions[0];
      }

      //Get Customer Addresses
      await sdk._getCustomerAddresses();

      //Get Payment Methods
      paymentData = await sdk._getPaymentMethods();

      //Get One-times Addons
      await sdk._getOnetimes();

      //Get GraphQL Products JSON
      await sdk._getProductsJsonByGraphQl();

      //Get Upcoming Charges
      allCharges = await sdk._getUpcomingCharges();
    }

    // Convert Customer PaymentMethods array to object for avoiding looping
    customerPaymentMethods = window.customerDetails.rechargePaymentMethods;

    //create Subscriptions HTML
    await this._createSubscriptionsHTML();

    await this._bindModalEvents();

    // Remove class for Button Loading after any action is executed successfully

    document.querySelector(".btn.loading")?.classList.remove("loading");
    if (successModalType != null && successModalType != "addon-success") {
      //Open Confirmation Modal after successfull api call
      this._showSuccessModal();
    }
    this._resetChangeFrequencyPopupDisplay(); // to initialize chnage frequency popup

    this._removeDisabledButton();

    //flag for delivery schedule after any update is done.
    scheduleDeliveryFlag = false;
    document.querySelector("#dashboard").removeAttribute("style");

    this._initResumeFlatpickrIfNeeded();
  }

  /**
   * Update next charge date for subscription and Addons
   *
   * @param {Number} subscription_id
   * @param {Date} nextChargeDate ( YYYY-MM-DD )
   */
  async _setNextChargeDate(subscription_id, nextChargeDate) {
    let response = await sdk._changeChargeDate(subscription_id, nextChargeDate);

    if (response) {
      // If Addons are connected with subscription change their dates also
      if (selectedAddons.length > 0) {
        let response2 = await sdk._changeChargeDateAddon(
          selectedAddons,
          nextChargeDate
        );
        if (response2) {
          this.onLoadData();
        }
      } else {
        this.onLoadData();
      }
    }
  }

  /**
   * Cancel Subscription and delete addons
   *
   * @param {Number} subscription_id
   * @param {String} reason
   * @param {String} feedback
   */
  async _cancelSubscription(subscriptionId, reason, feedback) {
    // If Addons are connected with subscription first delete them
    if (selectedAddons.length > 0) {
      let response = await sdk._removeOnetimeAddons(selectedAddons);
      if (response) {
        // Once Addons are deleted cancel the subscription
        let response2 = await sdk._cancelSubscription(
          subscriptionId,
          reason,
          feedback
        );
        if (response2) {
          this.onLoadData();
        }
      }
    } else {
      // If addons are not there directly cancel sunscription
      let response = await sdk._cancelSubscription(
        subscriptionId,
        reason,
        feedback
      );
      if (response) {
        this.onLoadData();
      }
    }
  }

  /**
   * Re-Activate Subscription
   *
   * @param {Number} subscription_id
   */
  async _reActivateSubscription(subscription_id) {
    let response = await sdk._reActivateSubscription(subscription_id);
    if (response) {
      this.onLoadData();
    }
  }

  /**
   * Update Subscription
   *
   * @param {Number} subscription_id
   * @param {JSON} updateSubscriptionObj : https://developer.rechargepayments.com/2021-11/subscriptions/subscriptions_update
   */
  async _updateSubscription(subscription_id, updateSubscriptionObj) {
    let response = await sdk._updateSubscription(
      subscription_id,
      updateSubscriptionObj
    );
    if (response) {
      this.onLoadData();
    }
  }

  /**
   * Create a one-time addon
   * @param {JSON} addonObj : https://developer.rechargepayments.com/2021-11/onetimes/onetimes_create
   */
  async _createOnetimeAddon(addonObj) {
    let response = await sdk._createOnetimeAddon(addonObj);
    if (response) {
      this.onLoadData();
      // Open Success bar of addon
      this._showElement("[add-on-success]");
    } else {
      this.dashboard.querySelector(".btn.loading")?.classList.remove("loading");
    }
  }

  /**
   * Create subscription product
   * @param {JSON} addonObj : https://developer.rechargepayments.com/2021-11/subscriptions/subscriptions_create
   */
  async _createSubscriptionProduct(subsDataObj) {
    let response = await sdk._createSubscriptionProduct(subsDataObj);
    if (response) {
      // successModalType="addon-success"
      this.onLoadData();
    } else {
      this.dashboard.querySelector(".btn.loading")?.classList.remove("loading");
    }
  }

  /**
    * Update one-time Addon product
    * 
    * @param {Number} addon_Id
    * @param {JSON} addonObj : https://developer.rechargepayments.com/2021-11/onetimes/onetimes_update
    
    */
  async _updateOnetimeAddon(addon_Id, addonObj) {
    let response = await sdk._updateOnetimeAddon(addon_Id, addonObj);
    if (response) {
      this.onLoadData();
    } else {
      this.dashboard.querySelector(".btn.loading")?.classList.remove("loading");
    }
  }

  /**
   * Remove one-time Addon product
   *  @param {Number} addon_Id
   */
  async _removeOnetimeAddon(addon_Id) {
    let response = await sdk._removeOnetimeAddon(addon_Id);
    if (response) {
      this.onLoadData();
    }
  }

  /**
   * Change Shipping Address
   *
   * @param {Number} address_id
   * @param {JSON} updatedAddressObj : https://developer.rechargepayments.com/2021-11/addresses/update_address
   */
  async _changeShippingAddress(address_id, updatedAddressObj) {
    let response = await sdk._changeShippingAddress(
      address_id,
      updatedAddressObj
    );
    if (response) {
      this.onLoadData();
    } else {
      // Remove class for Button Loading after any action has been failed.
      document.querySelector(".btn.loading")?.classList.remove("loading");
      document
        .querySelector("[data-update_shipping_address]")
        ?.classList.remove("disabled");
    }
  }

  /**
   * Apply Discount Based on charge id
   *
   * @param {Number} charge_id
   * @param {Number} discount_id
   */
  async _applyDiscountOnCharge(charge_id, discount_id) {
    let response = await sdk._applyDiscountOnCharge(charge_id, discount_id);
    if (response) {
      this.onLoadData();
    }
  }

  /**
   * Send an email notification
   *
   */
  async _updatePaymethodMethod() {
    let addressId = subscriptionData.address_id;
    paymentMethodId = customerAddresses[addressId].payment_method_id;
    let paymentSubdata = paymentData.find((x) => x.id == paymentMethodId);
    if (paymentSubdata.processor_name == "stripe") {
      window.location.href = `https://www.platecrate.com/tools/recurring/portal/${window.customerDetails.rechargeCustomerPortal.customer_hash}/payment_methods?token=${window.customerDetails.rechargeCustomerPortal.temp_token}`;
    } else {
      try {
        await recharge.customer.sendCustomerNotification(
          session,
          "SHOPIFY_UPDATE_PAYMENT_INFO",
          {
            address_id: addressId,
            payment_method_id: paymentMethodId,
          }
        );
        this.onLoadData();
        return true;
      } catch (err) {
        Rollbar.error(
          `Error in fetching _updatePaymethodMethod(): ${JSON.stringify(
            err
          )} , Customer Email: ${customerDetails.email}`
        );
        sdk.notification(
          "Something went wrong",
          "Please try again later",
          "error"
        );
        document.querySelector(".btn.loading")?.classList.remove("loading");
        return false;
      }
    }
  }

  /**
   * Skip/Unskip a charge
   *
   * @param {Number} subscription_id
   */
  async _skipUnskipCharge(event) {
    let is_skip = event.closest(".btn").getAttribute("data-skipped");
    let charge_id = event
      .closest(".btn")
      .closest("[data-charge_id]")
      .getAttribute("data-charge_id");
    let item_id = event.closest(".btn").getAttribute("data-item_id");
    event.closest(".btn").classList.add("loading");
    // call unskip
    if (is_skip === "true") {
      let response = await sdk._unSkipCharge(charge_id, item_id);
      if (response) {
        this.deliveryDetails();
      }
    } else {
      // call skip
      let response = await sdk._skipCharge(charge_id, item_id);
      if (response) {
        this.deliveryDetails();
      }
    }
  }

  /** *
   * Create Delivery Schedule HTML
   */
  _createDeliveryScheduleHTML() {
    deliverySchedules = window.customerDetails.rechargeDeliverySchedule;
    let deliveryScheduleHTML = "";

    deliverySchedules.forEach((currentValue) => {
      let ds_date = moment(currentValue.date).format("MMMM D, YYYY");

      // get all the products for a particular record
      let line_items_html = "";
      let line_items = currentValue.orders[0].line_items;
      let charge_id = currentValue.orders[0].charge_id;
      line_items.forEach((item) => {
        line_items_html += `<tr data-charge_id="${charge_id}">
                    <td> <img src="${
                      item.images.small
                        ? item.images.small
                        : "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png"
                    }" style="width:60px"> </td>
                    <td> 
                        ${
                          item.is_skipped
                            ? `Skipped: <span style="color: #8e8f8e">${item.product_title}</span>`
                            : `${item.product_title}`
                        }  
                    </td>
                    <td class="text-end"> ${item.quantity} </td>
                    <td class="text-end"> ${item.unit_price} </td>
                    <td class="text-center"> ${item.plan_type} </td>     
                    <td class="text-center"> 
                        ${
                          item.is_skippable && charge_id
                            ? `<a href="#" class="fw-semibold btn" data-skipped="${
                                item.is_skipped
                              }" data-item_id="${
                                item.subscription_id
                              }" data-date="${
                                currentValue.date
                              }" data-skip_unskip_delivery>
                                <span class="add-text">${
                                  item.is_skipped ? "Unskip" : "Skip"
                                }</span> 
                                <span class="spinner"></span>
                            </a>`
                            : " "
                        }
                    </td>
                    ${
                      currentValue.orders[0].id != null
                        ? `
                        <td class="text-center d-flex" data-order_id="${
                          currentValue.orders[0].id
                        }" data-reschedule-parent>
                            <input type="date" placeholder="Select date" min="${moment().format(
                              "YYYY-MM-DD"
                            )}" data-charge_datepicker="" class="form-control form-control-sm">
                            <a href="#" class="btn" data-reschedule-btn>
                                <span class="add-text">Reschdule</span>
                                <span class="spinner"></span>
                            </a>
                        </td>
                        `
                        : ""
                    }
                </tr>`;
      });

      // Main delivery schedule block HTML
      deliveryScheduleHTML += `<div class="my-5">
                <div class="h5 mb-3">${ds_date}</div>
                <table class="table">
                    <thead>
                    <tr>
                        <th scope="col" colspan="2">Product</th>
                        <th scope="col" class="text-end">Quantity</th>
                        <th scope="col" class="text-end">USD</th>
                        <th scope="col" class="text-center">Type</th>
                        <th scope="col" class="text-center"></th>
                        <th scope="col" class="text-center"></th>
                    </tr>
                    </thead>
                    <tbody>
                        ${line_items_html}
                    </tbody>
                </table>
            </div>`;
    });

    document.querySelector("[data-delivery_schedule]").innerHTML =
      deliveryScheduleHTML;

    // Remove Dashboard Loader When All the Onload APIs Call Successful
    document
      .querySelector("[data-loader_button_delivery_schedule]")
      ?.classList.add("d-none");

    this._bindDeliveryScheduleEvents();
  }

  /**
   * Create Addresses HTML
   */
  _createAddressesHTML() {
    let recharge_addresses = window.customerDetails.rechargeCustomerAddress;
    document.querySelector("[data-addresses]").innerHTML = "";

    const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

    let customerAddressesHTML = "";

    recharge_addresses.forEach((currentValue) => {
      customerAddressesHTML += `<div class="col-sm-6 mb-4" data-single_customer_address="">
                <div class="card min-h-100 border-gray-200">
                    <div class="card-body">
                        <div class="card-title">
                            <h5 class="d-inline-block">
                            <span data-address_first_name=""> ${
                              currentValue.first_name
                            } </span> 
                            <span data-address_last_name=""> ${
                              currentValue.last_name
                            } </span>
                            </h5>
                        </div>
                        <div class="card-text">
                            <p data-address_1="" class="m-0"> ${
                              currentValue.address1
                            } </p>
                            <p data-address_2="" class="m-0 ${
                              currentValue.address2 == null ? "d-none" : ""
                            }"> ${currentValue.address2} </p>
                            <p class="m-0"><span data-address_city=""> ${
                              currentValue.city
                            } </span> <span data-address_state="">${
        currentValue.province
      }</span> <span data-address_pincode="">${currentValue.zip}</span></p>
                            <p data-address_country="" class="m-0">${regionNames.of(
                              currentValue.country_code
                            )}</p>
                            <p data-address_phone="" class="m-0 ${
                              currentValue.phone == null ? "d-none" : ""
                            }">PH: ${currentValue.phone}</p>
                        </div>
                    </div>
                    <div class="card-footer border-gray-200 bg-transparent">
                        <a class="card-link" href="javascript:void(0);" data-toggle="modal" data-modal-opener="shippingaddress-modal" data-customer_address_id="${
                          currentValue.id
                        }">Edit</a>
                    </div>
                </div>
            </div>`;
    });

    document.querySelector("[data-addresses]").innerHTML =
      customerAddressesHTML;

    // Remove Dashboard Loader When All the Onload APIs Call Successful
    document
      .querySelector("[data-loader_button_addresses]")
      .classList.add("d-none");
  }

  _createSubscriptionsHTML() {
    allSubscriptions = window.customerDetails.rechargeSubscriptions;
    graphQLProductsJSON = window.customerDetails.graphQLProductsJSON;

    if (window.customerDetails.rechargeCustomerDetails) {
      customerAddresses = window.customerDetails.rechargeCustomerAddress;
      // Convert Customer Addresses array to object for avoiding looping
      let rechargeaddress = {};
      customerAddresses.map((address) => {
        rechargeaddress[address.id] = address;
      });
      customerAddresses = rechargeaddress;

      let rechargePaymentMethods = {};
      customerPaymentMethods.map((payment) => {
        rechargePaymentMethods[payment.id] = payment;
      });
      customerPaymentMethods = rechargePaymentMethods;

      // create Subscription HTML
      this._createSubscriptionHTML();
    } else {
      return false;
    }

    //Remove Dashboard Loader When All the Onload APIs Call Successful
    document.querySelector("[data-loader_button]").classList.add("d-none");
  }

  /**
   * Create payment HTML
   */
  _createBillingHTML() {
    let paymentHtml = "";
    customerPaymentMethods.map((payment) => {
      paymentHtml = paymentHtml + this._paymentRowHTML(payment);
    });
    document.querySelector("[data-subscription_billing]").innerHTML =
      paymentHtml;
  }

  /**
   * Create payment row HTML
   */
  _paymentRowHTML(payment) {
    return `
        <div class="border mb-5 table-responsive" data-payment-id="#${payment.id}">
        <table table-responsive="true" class="table biiling_table">
            <tbody>
                <tr>
                    <td class="font-size-xl fw-semibold ls-2">Card on File</td>
                    <td class="rc_text--base">
                        <p class="fw-medium mb-2" data-card-details=""><span class="text-capitalize" data-card-brand="">visa</span> ending in <span data-card-4digit="">${payment.payment_details.last4}</span></p>
                        <p class="fw-medium text-capitalize mb-2" data-card-exp-details="">Expires ${payment.payment_details.exp_month} / ${payment.payment_details.exp_year}</p>
                        <p class="d-none"><a href="#" data-update-card="" class="font-size-md fw-bold text-uppercase">Update Card</a></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p class="font-size-xl fw-semibold ls-2">Billing Information</p>
                    </td>
                    <td class="rc_text--base">
                        <p class="fw-normal ls-2 mb-0" data-original-billing-address="">
                            <span class="mb-2 d-block fw-medium" data-billing-name="">${payment.billing_address.first_name} ${payment.billing_address.last_name}</span>
                            <span class="mb-2 d-block fw-medium" data-billing-address1="">${payment.billing_address.address1}</span>
                            <span class="mb-2 d-block fw-medium" data-billing-province="">${payment.billing_address.province}</span>
                            <span class="mb-2 d-block fw-medium" data-billing-countryname="">${payment.billing_address.country}</span>
                        </p>
                        <p>
                            <a href="#" class="btn btn-fill ps-0"   data-modal-opener="UpdatePayment-modal" data-payment-${payment.processor_name}>
                                <span class="add-text">Send update email</span>
                            </a>
                        </p>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>`;
  }

  /**
   * ROW Active Subscriptions HTML
   * @param {JSON} subscription
   */
  _activeSubscriptionRowHTML(subscription) {
    let variant = graphQLProductsJSON[
      subscription.external_product_id.ecommerce
    ].variants.filter((itm) => {
      if (
        itm.external_variant_id == subscription.external_variant_id.ecommerce
      ) {
        return itm;
      }
    });

    variant = variant[0];
    let x = this._activeHTMLstyle1(subscription, variant);
    return x;
  }

  // style1
  _activeHTMLstyle1(subscription, variant) {
    //To add addon
    let addonHtml = this._addonHtml(subscription.id);
    let properties = "";
    let chargeObj = allCharges?.find((charge) => {
      return charge.line_items.find((item) => {
        return item.purchase_item_id == subscription.id;
      });
    });

    subscription.properties.forEach((property) => {
      if (property.name === "Age" || property.name == "Position") {
        properties =
          properties +
          `<li><strong class="fw-medium">${property.name}:</strong> ${property.value}</li>`;
      } else if (
        property.name === "product_type" &&
        property.value === "platecrate-pro"
      ) {
        is_proProductExist = true;
      } else if (
        property.name === "product_type" &&
        property.value === "platecrate"
      ) {
        is_platecrateProductExist = true;
      } else if (
        property.name === "product_type" &&
        property.value === "platecrate-lite"
      ) {
        is_liteProductExist = true;
      }
    });

    if (subscription.is_prepaid === false) {
      is_monthlyActiveExist = true;
    }

    let priceEle = `<td class="end-text subtable-total text-md-end text-start text-russian" data-title="total">${Shopify.formatMoney(
      parseFloat(subscription.price).toFixed(2),
      window.globalVariables.money_format
    )}</td>`;
    if (chargeObj != null && chargeObj.discounts.length > 0) {
      let DiscountedPrice;
      if (chargeObj.discounts[0].value_type == "percentage") {
        DiscountedPrice =
          parseFloat(subscription.price) -
          (parseFloat(subscription.price) *
            parseFloat(chargeObj.discounts[0].value)) /
            100;
      } else if (chargeObj.discounts[0].value_type == "fixed_amount") {
        DiscountedPrice =
          parseFloat(subscription.price) - chargeObj.discounts[0].value;
      }
      priceEle = `<td class="end-text subtable-total text-md-end text-start text-russian" data-title="total"><del class="d-block font-size-md">${Shopify.formatMoney(
        parseFloat(subscription.price).toFixed(2),
        window.globalVariables.money_format
      )}</del><strong>${Shopify.formatMoney(
        parseFloat(DiscountedPrice).toFixed(2),
        window.globalVariables.money_format
      )}</strong></td>`;
    }

    return `
            <tr class="recharge-active ${
              subscription.next_charge_scheduled_at != null ? "" : "disabled"
            }" data-single-active-subscription="${subscription.id}" subtype="${
      subscription.is_prepaid
    }" data-subscription-id="${subscription.id}">
                <td class="subtable-product">
                <div class="subscription-media">
                    <div class="media-image">
                        <img src="${
                          variant.image
                            ? variant.image
                            : graphQLProductsJSON[
                                subscription.external_product_id.ecommerce
                              ].images
                        }" alt="${
      subscription.product_title
    }" width="125" height="125" loading="lazy">
                    </div>
                    <div class="media-content">
                        <h5 class="h6 fw-bold text-capitalize">${
                          subscription.product_title
                        }</h5>
                        <ul class="subscription-lineitem text-russian">
                            ${
                              subscription.variant_title
                                ? `<li><strong class="fw-medium">shirt size:</strong>${subscription.variant_title}</li>`
                                : ""
                            }
                            ${properties}
                        </ul>
                    </div>
                </div>
            </td>

            <td class="subtable-qty text-russian" data-title="qty">${
              subscription.quantity
            }</td>
            <td class="subtable-frequency text-russian" data-title="frequency">${
              subscription.order_interval_frequency
            } ${subscription.order_interval_unit}</td>
            <td class="subtable-shipdate text-russian" data-title="next ship date">${
              subscription.next_charge_scheduled_at != null
                ? moment(subscription.next_charge_scheduled_at).format(
                    "MMMM DD, YYYY"
                  )
                : this._checkChargeError(subscription)
            }</td>
                ${priceEle}
              <td class="subtable-edit text-end">
                <button type="button" class="btn btn-secondary btn-sm bg-transparent border-0 p-0" data-modal-opener="editsubscription-modal">
                  <span class="d-flex align-items-center">
                    <span class="add-text">edit</span>
                    <span class="spinner"></span>
                  </span>
                </button>
              </td>
            </tr>
            ${addonHtml}
        `;
  }

  _createSubscriptionHTML() {
    let isPrepaidSubscriptionExist = false;
    // active subscriptions
    activeSubscriptions = allSubscriptions.filter((subscription) => {
      if (subscription.status.toLowerCase() == "active") {
        if(subscription.is_prepaid)  isPrepaidSubscriptionExist = true;
        return subscription;
      }
    });
    // inactive subscriptions
    inActiveSubscriptions = allSubscriptions.filter((subscription) => {
      if (subscription.status.toLowerCase() == "cancelled") {
        return subscription;
      }
    });
    // address html
    let addresses = window.customerDetails.rechargeCustomerAddress;
    document.querySelector("[data-active-subscriptions]").innerHTML = "";
    let viewHTML = "";
    let modal_html_active_sub = "";
    let modal_html_active_monthly_sub = "";
    if (addresses.length > 0) {
      document
        .querySelector("[data-active-subscriptions]")
        .classList.remove("d-none");
      activeSubscriptions.forEach((sub) => {
        viewHTML = viewHTML + this._activeSubscriptionRowHTML(sub);
        // if (is_proProductExist == false && is_monthlyActiveExist == true) {
        //   viewHTML = viewHTML + this.swapBannerHTML(sub);
        // }
        let html = `<div data-single-active-subscription="${sub.id}" data_is_prepaid='${sub.is_prepaid}' data-subscription-id="${sub.id}" class="col-md-4 col-12 px-2 mb-3" data-modal-opener="one-time-product-popup">
                            <div class="active-subscription"><p>${sub.product_title}</p></div>
                        </div>`;
        modal_html_active_sub = modal_html_active_sub + html;

        if (sub.is_prepaid === false) {
          let activeMontlySubscription = `<div data-single-active-subscription="${sub.id}" data-modal-opener='platcrate_pro_subscription-modal' data-subscription-id="${sub.id}">
                        <label class="mb-0 d-block text-center" tabindex="0" role="button" for="pause_1_month">${sub.product_title}</label>
                    </div>`;
          modal_html_active_monthly_sub =
            modal_html_active_monthly_sub + activeMontlySubscription;
        }
      });

      document.querySelector("[data-inactive-subscriptions]").innerHTML = "";
      if (inActiveSubscriptions.length > 0) {
        document
          .querySelector("[data-inactive-subscriptions]")
          .classList.remove("d-none");
        let inActiveHtml = "";
        inActiveSubscriptions.forEach((sub) => {
          inActiveHtml = inActiveHtml + this._inActiveSubscriptionRowHTML(sub);
        });
        let viewHTML_inactive = `<h2 class="h3 text-capitalize mb-3">inactive subscription</h2>
                        <div class="account-block disabled-block pb-0">
                            <div class="account-subscription-table">
                                <table class="table mb-0">
                                    <thead>
                                        <tr>
                                            <th>product</th>
                                            <th>qty</th>
                                            <th>frequency</th>
                                            <th class="end-text">total</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                ${inActiveHtml}
                                    </tbody>
                                </table>
                            </div>
                        </div>`;
        document.querySelector("[data-inactive-subscriptions]").innerHTML =
          viewHTML_inactive;
        document
          .querySelectorAll("[data-reactive_subscription]")
          .forEach((ele) => {
            ele.addEventListener("click", (event) => {
              event.stopImmediatePropagation();
              event.preventDefault();
              let currentEle = event.currentTarget;
              currentEle.querySelector(".spinner").classList.remove("d-none");
              let id = event.target
                .closest("[data-single-inactive-subscription]")
                .getAttribute("data-single-inactive-subscription");
              event.target
                .closest("[data-reactive_subscription]")
                ?.classList.add("loading");
              this._reActivateSubscription(id);
            });
          });
      }

      let viewHTML_active = "";
      let addOnModal = document.querySelector("#one-time-product-popup");
      let addOnBtnHTML =
        '<button class="btn btn-primary bg-transparent border-0 p-0 btn-block" data-modal-type="addon-modal" data-modal-opener="active_subscription-modal"><span>add one-time products</span></button>';
      if (activeSubscriptions.length > 0) {
        let proProductHTMl = "";
        let is_only_pro_banner_visible = !is_proProductExist && is_platecrateProductExist && !is_liteProductExist
        if (!isPrepaidSubscriptionExist) {
          proProductHTMl = ` <tr>
              <td colspan="6" class="mx-auto">
                  <div class="d-lg-block ${is_only_pro_banner_visible ? "" : "d-none"}">
                    <div class="account-swapsub ${is_only_pro_banner_visible ? "" : "d-none"}" style="background-color:${swapBannerData.backgroundColor};">
                        <h4 class="mb-4 text-center">${swapBannerData.heading}</h4>
                        <div class="account-swapsub-inner">
                            <div class="inner-sec1 text-lg-start text-center">
                              <span class="badge bg-secondary mb-2">${swapBannerData.badgeTitle}</span>
                                <h5 class="mb-0">${swapBannerData.planTitle}</h5>
                                <p class="fw-medium mb-0">Starts at <strong class="h4 d-block text-capitalize fw-medium mb-0">
                                  <span class="text-secondary fw-bold">$${swapBannerData.startingPrice}</span> / crate</strong>
                                </p>
                            </div>
                            <div class="inner-sec2">
                                <ul class="list-unstyled text-start mb-0">
                                  ${swapBannerData.listItems}
                                </ul>
                            </div>
                            <div class="inner-sec3">
                                <button class="btn btn-secondary btn-sm bg-transparent border-0 p-0" data-subscription-type-in-model="platecrate-pro" data-modal-type='platcrate_pro_subscription-modal' data-modal-opener="monthly_active_subscription-modal">
                                  <span class="d-flex align-items-center">
                                    <span class="add-text">${swapBannerData.buttonTitle}</span>
                                    <span class="spinner"></span>
                                  </span>
                                </button>
                            </div>
                          </div>
                      </div>
                  </div>
                  <div class="row align-items-center mt-n3 ${is_only_pro_banner_visible ? "d-none" : ""}" style="--bs-container-padding: 10px;">
                      <div class="col-lg-6 mt-3 ${is_liteProductExist && !is_platecrateProductExist? "" : "d-none"}">
                          <div class="account-swapsub-dual" style="background-color:${plateCrateSwapBannerData.backgroundColor};">
                              <span class="popular-badge"></span>
                              <div class="account-swapsub-inner">
                                  <div class="inner-sec1">
                                      <h4 class="m-0">${plateCrateSwapBannerData.planTitle}</h4>
                                      <p class="fw-medium mb-0">Starts at 
                                        <strong class="h4 d-block text-capitalize fw-medium mb-0 mt-2">
                                          <span class="text-secondary fw-bold">$${plateCrateSwapBannerData.startingPrice}</span> / crate
                                        </strong>
                                      </p>
                                  </div>
                                  <div class="inner-sec2">
                                      <ul class="list-unstyled mb-0">${plateCrateSwapBannerData.listItems}</ul>
                                  </div>
                                  <div class="inner-sec3">
                                      <button class="btn btn-secondary btn-sm bg-transparent border-0 p-0 btn-block" data-subscription-type-in-model="platecrate" data-modal-type='platcrate_pro_subscription-modal' data-modal-opener="monthly_active_subscription-modal">
                                        <span class="d-flex align-items-center">
                                          <span class="add-text">${plateCrateSwapBannerData.buttonTitle}</span>
                                          <span class="spinner"></span>
                                        </span>
                                      </button>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="col-lg-6 mt-3 ${is_proProductExist ? "d-none" : ""}">
                          <div class="account-swapsub-dual" style="background-color:${swapBannerData.backgroundColor};">
                              <span class="popular-badge">${swapBannerData.badgeTitle}</span>
                              <div class="account-swapsub-inner">
                                  <div class="inner-sec1">
                                      <h5 class="mb-0">${swapBannerData.planTitle}</h5>
                                      <p class="fw-medium mb-0">Starts at 
                                        <strong class="h4 d-block text-capitalize fw-medium mb-0 mt-2">
                                          <span class="text-secondary fw-bold">$${swapBannerData.startingPrice}</span> / crate
                                        </strong>
                                      </p>
                                  </div>
                                  <div class="inner-sec2">
                                      <ul class="list-unstyled mb-0">${swapBannerData.listItems}</ul>
                                  </div>
                                  <div class="inner-sec3">
                                      <button class="btn btn-secondary btn-sm bg-transparent border-0 p-0 btn-block" data-subscription-type-in-model="platecrate-pro" data-modal-type='platcrate_pro_subscription-modal' data-modal-opener="monthly_active_subscription-modal">
                                        <span class="d-flex align-items-center">
                                          <span class="add-text">${swapBannerData.buttonTitle}</span>
                                          <span class="spinner"></span>
                                        </span>
                                      </button>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </td>
          </tr>`;
        }
        viewHTML_active = `<div class="customer-detail-block">
                            <div class="cdb-address pe-xl-5 pe-md-4">
                                <h6 class="mb-1">${
                                  window.customerDetails.rechargeCustomerDetails
                                    .first_name
                                } ${
          window.customerDetails.rechargeCustomerDetails.last_name
        }</h6>
                                <h6 class="mb-2">${
                                  addresses[0].address1
                                } ${
          addresses[0].address2 ? addresses[0].address2 : ""
        },
                                ${addresses[0].city}, ${
          addresses[0].province
        } ${addresses[0].zip}, ${addresses[0].zip} ${
          addresses[0].country_code
        }</h6>
                                <a href="#" data-customer_address_id="${
                                  addresses[0].id
                                }" data-modal-type="shippingaddress-modal" data-modal-opener="active_subscription-modal" class="text-decoration-underline">Edit Shipping Address</a>
                            </div>
                            ${
                              window.customerDetails.rechargePaymentMethods[0]
                                ? `<div class="cdb-billing-detail px-xl-5 px-lg-4">
                                <h6 class="mb-2">visa ********${window.customerDetails.rechargePaymentMethods[0].payment_details.last4}</h6> 
                                <a href="#" data-customer_address_id="${addresses[0].id}" data-modal-type="UpdatePayment-modal" data-modal-opener="active_subscription-modal" class="text-decoration-underline" target='_blank'>Update Billing</a>

                                </div>`
                                : ``
                            }
                            <div class="cdb-discount-code">
                                <a href="javascript:void(0)" data-modal-type='PopupModal-promocode' data-modal-opener='active_subscription-modal' class="text-decoration-underline">Have a discount code?</a>
                            </div>
                        </div>
                        <div class="account-subscription-table">
                            <table class="table mb-2">
                                <thead>
                                    <tr>
                                        <th>product</th>
                                        <th>qty</th>
                                        <th>frequency</th>
                                        <th>next ship date</th>
                                        <th class="end-text">total</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    ${viewHTML}
                                    ${proProductHTMl}
                                </tbody>
                            </table>
                        </div>
                        ${addOnModal ? addOnBtnHTML : ""}
                    `;
      } else {
        viewHTML_active = `<p class="text-center mb-0"> No Active Subscription</p>`;
      }
      const active_subs_model = document.querySelector("[modal-active-subscription]")
      if(active_subs_model)
      active_subs_model.innerHTML =
        modal_html_active_sub;
      // document.querySelector('[modal-monthly-active-subscription]').innerHTML = modal_html_active_monthly_sub;
      document.querySelector("[data-active-subscriptions]").innerHTML =
        viewHTML_active;

      // set listners to reactive btn
      document
        .querySelectorAll("[data-reactive_subscription]")
        .forEach((ele) => {
          ele.addEventListener("click", (event) => {
            event.stopImmediatePropagation();
            event.preventDefault();
            let id = event.target
              .closest("[data-single-inactive-subscription]")
              .getAttribute("data-single-inactive-subscription");
            event.target
              .closest("[data-reactive_subscription]")
              ?.classList.add("loading");
            this._reActivateSubscription(id);
          });
        });

      if (
        document.querySelectorAll("[data-single-active-subscription]").length >
        0
      ) {
        document
          .querySelectorAll("[data-single-active-subscription]")
          .forEach((ele) => {
            ele.addEventListener("click", (event) => {
              this._selectCurrentSubscription(event);
            });
          });
      }
    } else {
      document
        .querySelector("[data-active-subscriptions]")
        .classList.remove("d-none");
      let viewHTML_active = `<p class="text-center mb-0"> No Active Subscription</p>`;
      document.querySelector("[data-active-subscriptions]").innerHTML =
        viewHTML_active;
    }
  }

  _selectCurrentSubscription(event) {
    let currentEle = event.currentTarget;
    let subId = parseInt(
      currentEle.getAttribute("data-single-active-subscription")
    );
    subscriptionData = activeSubscriptions.find((x) => x.id == subId);
    if (subscriptionData != "") {
      document.querySelectorAll("[data-upgrade-to-btn]").forEach((ele) => {
        ele.classList.remove("disabled");
      });
    }
  }

  /**
   * Create address row
   * @param {JSON} address
   */
  // _addressRowHTML(address){

  //     // let style = this._activeHTMLstyle2(subscription,variant);
  //     let style = `
  //     <div class="d-flex align-items-center pb-4 mx-md-n3 mx-0 justify-content-between">
  //         <div class="mb-md-0 mb-6 ps-xl-4 ps-md-3 pe-md-3 px-0 border-end border-dark">
  //             <div class="mb-1">
  //                 <p class="font-size-xl fw-bold ls-0 mb-md-2 mb-1" data-customer_name>${address.first_name} ${address.last_name}</p>
  //                 <p class="font-size-xl fw-bold ls-0 mb-1 pb-md-0 pb-1" data-customer_address>
  //                     ${address.address1} ${address.address2} ${address.city}, ${address.province} ${address.zip}
  //                 </p>
  //             </div>
  //             <a href="#" class="fill-details font-size-sm fw-medium text-decoration-underline" data-customer_address_id="${address.id}" data-modal-opener="shippingaddress-modal">Edit Shipping Address</a>
  //         </div>
  //         <div class="ps-md-7 ps-md-3 pe-md-3 px-0">
  //             <p class="font-size-xl fw-bold ls-0 mb-1"><span class="text-capitalize lh-base" data-visa="">visa</span> ****<span data-4digit="">9938</span></p>
  //             <div class="d-flex align-items-center justify-content-between">
  //                 <a href="#" class="fill-details fw-medium font-size-sm text-decoration-underline" data-update-billing-link="">Update Billing</a>
  //             </div>
  //         </div>
  //         </div>
  //     `

  //     return style;
  // }

  /**
   * Create AddOn HTML
   */
  _addonHtml(subscriptionId) {
    let connectedAddons = [];
    window.customerDetails.rechargeOnetimes.map((addon) => {
      addon.properties.map((prop) => {
        if (
          prop.name == "connected_subscription_id" &&
          prop.value == subscriptionId
        ) {
          connectedAddons.push(addon);
        }
      });
    });

    let addonHtml = "";

    connectedAddons.forEach((addon) => {
      let addon_img_src = "";
      if (
        graphQLProductsJSON[addon.external_product_id.ecommerce].images == null
      ) {
        addon_img_src = window.globalVariables.settings.no_image_replacement;
      } else {
        // get variant image
        let var_img = graphQLProductsJSON[
          addon.external_product_id.ecommerce
        ].variants.filter((ele) => {
          if (ele.external_variant_id == addon.external_variant_id.ecommerce) {
            return ele;
          }
        });
        if (var_img[0].image == null) {
          addon_img_src =
            graphQLProductsJSON[addon.external_product_id.ecommerce].images;
        } else {
          addon_img_src = var_img[0].image.src;
        }
      }

      addonHtml += `<tr data-onetime-id="${addon.id}">
                            <td class="subtable-product">
                                <div class="subscription-media">
                                    <span class="badge">one-time</span>
                                    <div class="media-image">
                                        <img src="${addon_img_src}" alt="${
        addon.product_title
      }" width="125" height="125" loading="lazy">
                                    </div>
                                    <div class="media-content">
                                        <h5 class="h6 fw-bold text-capitalize">${
                                          addon.product_title
                                        }</h5>
                                    </div>
                                </div>
                            </td>
                            <td class="subtable-qty text-russian" data-title="qty">${
                              addon.quantity
                            }</td>
                            <td class="subtable-frequency text-russian" data-title="frequency">-</td>
                            <td class="subtable-shipdate text-russian" data-title="next ship date">${
                              addon.next_charge_scheduled_at != null
                                ? moment(addon.next_charge_scheduled_at).format(
                                    "MMMM DD, YYYY"
                                  )
                                : this._checkChargeError(addon)
                            }</td>
                            <td class="end-text subtable-total text-md-end text-start text-russian" data-title="total">${Shopify.formatMoney(
                              addon.price * addon.quantity * 100,
                              window.globalVariables.money_format
                            )}</td>
                            <td class="subtable-edit edit-remove-icon text-end">
                                <a href="#" class="text-secondary d-inline-block p-0 me-2" data-addon-remove="${addon.id}">
                                  <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                    <use href="#icon-delete"></use>
                                  </svg>
                                </a>

                                <button data-modal-opener="editaddon-modal" type="button" class="btn btn-secondary btn-sm bg-transparent border-0 p-0">
                                  <span class="d-flex align-items-center">
                                    <span class="add-text">edit</span>
                                    <span class="spinner"></span>
                                  </span>
                                </button>
                            </td>
                        </tr>`;
    });

    return addonHtml;
  }

  /**
   * ROW In-Active Subscriptions HTML
   * @param {JSON} subscription
   */
  _inActiveSubscriptionRowHTML(subscription) {
    let variant = graphQLProductsJSON[
      subscription.external_product_id.ecommerce
    ].variants.filter((itm) => {
      if (
        itm.external_variant_id == subscription.external_variant_id.ecommerce
      ) {
        return itm;
      }
    });
    variant = variant[0];
    let x = this._inActiveHTMLstyle1(subscription, variant);
    return x;
  }

  //Style 1
  _inActiveHTMLstyle1(subscription, variant) {
    let properties = "";

    subscription.properties.forEach((property) => {
      if (property.name == "Age" || property.name == "Position") {
        properties =
          properties +
          `<li><strong class="fw-medium">${property.name}:</strong> ${property.value}</li>`;
      }
    });

    return `
        <tr class="recharge-item recharge-inactive" data-single-inactive-subscription="${
          subscription.id
        }">

        <td class="subtable-product">
                <div class="subscription-media">
                    <div class="media-image">
                        <img src="${
                          variant.image
                            ? variant.image
                            : graphQLProductsJSON[
                                subscription.external_product_id.ecommerce
                              ].images
                        }" alt="${
      subscription.product_title
    }" width="125" height="125" loading="lazy">
                    </div>
                    <div class="media-content">
                        <h5 class="h6 fw-bold text-capitalize">${
                          subscription.product_title
                        }</h5>
                        <ul class="subscription-lineitem">
                            ${
                              subscription.variant_title
                                ? `<li><strong class="fw-medium">shirt size:</strong>${subscription.variant_title}</li>`
                                : ""
                            }
                            ${properties}
                        </ul>
                    </div>
                </div>
            </td>
            <td class="subtable-qty" data-title="qty">${
              subscription.quantity
            }</td>
            <td class="subtable-frequency" data-title="frequency">${
              subscription.order_interval_frequency
            } ${subscription.order_interval_unit}</td>
            <td class="end-text subtable-total" data-title="total"><strong>${Shopify.formatMoney(
              subscription.price * subscription.quantity * 100,
              window.globalVariables.money_format
            )}</strong></td>
            <td class="non-disabled subtable-edit">
              <a href="javascript:void(0)" class="fw-bold paragraph-md text-primary text-uppercase" data-reactive_subscription>
                <span class="d-inline-flex align-items-center justify-content-center">
                  <span class="add-text">reactivate</span>
                  <span class='spinner d-none'></span>
                </span>
              </a>
            </td>

        </tr>
        `;
  }

  // Display Charges Error
  _checkChargeError(subscription) {
    try {
      let subscriptionCharges = [];
      subscriptionCharges = allCharges.filter((charge) => {
        let itm = charge.line_items.find((item) => {
          return item.purchase_item_id == subscription.id;
        });
        if (itm != undefined) {
          return itm;
        }
      });
      let chargeError = subscriptionCharges.filter((charge) => {
        if (charge.error_type != null) {
          return charge;
        }
      });
      chargeError = chargeError[0];
      if (chargeError != undefined) {
        return `<strong class="text-danger"> ${chargeError.error_type}</strong>`;
      } else {
        return `<strong class=""> - - - </strong>`;
      }
    } catch (err) {
      Rollbar.error(`Error in charge: ${error}`);
      return `<strong class="text-danger">Error</strong>`;
    }
  }

  /**
   * Bind Modal Events After Loading All The Subscriptions
   */
  _bindModalEvents() {
    const cancelSubModal = document.getElementById("cancelsub-modal");
    if (cancelSubModal && !cancelSubModal.dataset.cancelReasonDelegated) {
      cancelSubModal.dataset.cancelReasonDelegated = "true";
      cancelSubModal.addEventListener("change", (event) => {
        const t = event.target;
        if (
          !t ||
          !t.matches ||
          !t.matches("[data-cancel-subscription-reason-select]")
        ) {
          return;
        }
        this._onCancelSubscriptionReasonChange(event);
      });
    }

    document.querySelectorAll("[data-modal-opener]").forEach((ele) => {
      ele.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (activeSubscriptions.length == 1) {
          subscriptionData = activeSubscriptions[0];
        }

        document.querySelectorAll(".modal.open").forEach((modal) => {
          modal.classList.remove("open");
        });
        let id = ele.getAttribute("data-modal-opener");

        if (id == "active_subscription-modal") {
          let isProModal = ele.hasAttributes("data-upgrade-to-pro");

          modalType = ele.getAttribute("data-modal-type");
          if (modalType == "payment-modal") {
            id = "UpdatePayment-modal";

            // let dataframe= `<iframe width="100%" src="https://shopifysubscriptions.com/customer_portal_forms/${window.customerDetails.rechargeCustomerDetails.hash}/customer_card" name="payment-form" id="payment-form"></iframe>`;
            //     document.querySelector("[payment-iframe]").innerHTML = dataframe;
          } else if (modalType == "UpdatePayment-modal") {
            if (activeSubscriptions.length == 1) {
              subscriptionData = activeSubscriptions[0];
              let addressId = subscriptionData.address_id;
              paymentMethodId = customerAddresses[addressId].payment_method_id;
              let paymentSubdata = paymentData.find(
                (x) => x.id == paymentMethodId
              );
              if (paymentSubdata.processor_name == "stripe") {
                window.location.href = `https://www.platecrate.com/tools/recurring/portal/${window.customerDetails.rechargeCustomerPortal.customer_hash}/payment_methods?token=${window.customerDetails.rechargeCustomerPortal.temp_token}`;
              } else {
                id = "UpdatePayment-modal";
              }
            } else {
              document
                .querySelectorAll("[data-single-active-subscription]")
                .forEach((elements) => {
                  elements.setAttribute(
                    "data-modal-opener",
                    "UpdatePayment-modal"
                  );
                });
            }
          } else if (modalType == "addon-modal") {
            if (activeSubscriptions.length == 1) {
              id = "one-time-product-popup";
            }
          } else if (modalType == "PopupModal-promocode") {
            document.querySelector("[data-promocode]").value = "";
            document
              .querySelector("[data-apply_promocode]")
              .classList.add("disabled");
            if (activeSubscriptions.length == 1) {
              id = "PopupModal-promocode";
            }
          } else if (modalType == "shippingaddress-modal") {
            document
              .querySelectorAll("[data-update_shipping_address]")
              .forEach((ele) => {
                ele.classList.add("d-none");
              });
            if (activeSubscriptions.length == 1) {
              id = "shippingaddress-modal";
              subscriptionData = activeSubscriptions[0];
            }
          }
          if (isProModal == true) {
            document.querySelectorAll("[data_is_prepaid]").forEach((ele) => {
              if (ele.getAttribute("data_is_prepaid") == true) {
                ele.classList.add("d-none");
              }
            });
          } else {
            document.querySelectorAll("[data_is_prepaid]").forEach((ele) => {
              ele.classList.remove("d-none");
            });
          }

          // Hide Addon Success Modal Bar
          this._hideElement("[add-on-success]");
        } else if (id == "cancelsub-modal") {
          this._resetCancelModalFeedback();
        } else if (id == "cancelsub-discount-modal") {
          // if (subscriptionData.is_prepaid == true) {
          //     id = 'cancelsub-modal'
          // }
          document
            .querySelector("[data-cancel_subscriptions]")
            .classList.add("d-none");
        } else if (id == "monthly_active_subscription-modal") {
          modalType = ele.getAttribute("data-modal-type");
          if (modalType == "platcrate_pro_subscription-modal") {
            isProOpen = true;
            if (activeSubscriptions.length == 1) {
              id = "edit-product-popup";
              subscriptionData = activeSubscriptions[0];
              const subsType = ele.getAttribute(
                "data-subscription-type-in-model"
              ); // Checking subscription type
              this._handleSwapPopupData(subsType); // displaying subscription variants as per the subscription type
            } else {
              let count = 0;
              activeSubscriptions.forEach((sub) => {
                if (sub.is_prepaid == false) {
                  count = count + 1;
                  subscriptionData = sub;
                }
              });
              if (count == 1) {
                id = "edit-product-popup";
              } else {
                document
                  .querySelectorAll("[data-single-active-subscription]")
                  .forEach((ele) => {
                    ele.setAttribute("data-modal-opener", "edit-product-popup");
                  });
              }
            }
          }
          //   document.querySelectorAll("[data-product-type]").forEach((ele) => {
          //     let type = ele.getAttribute("data-product-type");
          //     if (ele.closest("[data-swap-wrap]") != null) {
          //       if (type == "platecrate-pro") {
          //         ele.closest("[data-swap-wrap]").classList.remove("d-none");
          //       } else {
          //         ele.closest("[data-swap-wrap]").classList.add("d-none");
          //       }
          //     }
          //   });
        } else if (id == "changesubscription-modal") {
          document
            .querySelector("[data-update_subscription_btn]")
            .classList.add("d-none");
        } else if (id == "UpdatePayment-modal") {
          let subscriptionId = ele.getAttribute("data-subscription-id");
          subscriptionId = parseInt(subscriptionId);

          let currentSubscription = activeSubscriptions.find(
            (x) => x.id == subscriptionId
          );
          let addressId = currentSubscription.address_id;
          paymentMethodId = customerAddresses[addressId].payment_method_id;
          let paymentSubdata = paymentData.find((x) => x.id == paymentMethodId);
          if (paymentSubdata.processor_name == "stripe") {
            window.location.href = `https://www.platecrate.com/tools/recurring/portal/${window.customerDetails.rechargeCustomerPortal.customer_hash}/payment_methods?token=${window.customerDetails.rechargeCustomerPortal.temp_token}`;
          } else {
            id = "UpdatePayment-modal";
          }
        }

        if (modalType == "addon-modal") {
          document
            .querySelectorAll("[data-single-active-subscription]")
            .forEach((ele) => {
              ele.setAttribute("data-modal-opener", "one-time-product-popup");
            });
        } else if (modalType == "payment-modal") {
          document
            .querySelectorAll("[data-single-active-subscription]")
            .forEach((ele) => {
              ele.setAttribute("data-modal-opener", "UpdatePayment-modal");
            });
        } else if (modalType == "PopupModal-promocode") {
          document
            .querySelector("[data-apply_promocode]")
            .classList.add("disabled");
          document
            .querySelectorAll("[data-single-active-subscription]")
            .forEach((ele) => {
              ele.setAttribute("data-modal-opener", "PopupModal-promocode");
            });
        } else if (modalType == "shippingaddress-modal") {
          document
            .querySelectorAll("[data-update_shipping_address]")
            .forEach((ele) => {
              ele.classList.add("d-none");
            });
          document
            .querySelectorAll("[data-single-active-subscription]")
            .forEach((ele) => {
              ele.setAttribute("data-modal-opener", "shippingaddress-modal");
            });
        }
        document.querySelector(`#${id}`).show();
        this._showCurrentSubscription(event, id, ele);
      });
    });

    if (document.querySelectorAll("[data-addon-remove]") != null) {
      document.querySelectorAll("[data-addon-remove]").forEach((ele) => {
        let addon_id = ele.getAttribute("data-addon-remove");
        ele.addEventListener("click", (event) => {
          event.preventDefault();
          event.target.closest("[data-addon-remove]")?.classList.add("loading");
          let response = sdk._removeOnetimeAddon(addon_id);
          if (response) {
            this.onLoadData();
          }
        });
      });

      if (document.querySelector("[addon-add_more]") != null) {
        document
          .querySelector("[addon-add_more]")
          .addEventListener("click", () => {
            this._hideElement("[add-on-success]");
          });
      }
    }

    // To update variant for addon & edit subscription.
    document.querySelectorAll("[data-edit-card]").forEach((ele) => {
      ele.querySelectorAll("[data-editProduct_variant]").forEach((option) => {
        option.addEventListener("change", () => {
          let productOptions = [];
          ele.querySelectorAll("[data-editProduct_variant]").forEach((ele) => {
            productOptions.push(ele.value);
          });
          let addonProduct = JSON.parse(
            ele
              .closest("[data-edit-card]")
              .querySelector("[data-editProduct_productjson]").innerText
          );
          let addonVariants = addonProduct.variants;

          selectedAddonVariant = this._updateVariant(
            addonVariants,
            productOptions
          );
          ele
            .closest("[data-edit-card]")
            .querySelector("[add-addon]")
            .setAttribute("data-addon_option", selectedAddonVariant.id);

          if (
            ele
              .closest("[data-edit-card]")
              .querySelector("[data-editProduct_option]")
          ) {
            ele
              .closest("[data-edit-card]")
              .querySelector("[data-editProduct_option]")
              .setAttribute("data-editProduct_option", selectedAddonVariant.id);
          }
          if (
            ele.closest("[data-edit-card]").querySelector("[data-currentprice]")
          ) {
            ele
              .closest("[data-edit-card]")
              .querySelector("[data-currentprice]").innerHTML =
              Shopify.formatMoney(
                selectedAddonVariant.price,
                window.globalVariables.money_format
              );
          }
        });
      });
    });
    this._bindOnLoadEvents();
  }

  /**
   * Bind useful events After Loading All The
   */
  _bindOnLoadEvents() {
    // Bind Click Event on Changing Frequency Modal
    document
      .querySelectorAll("[data-update-subscription_frq]")
      .forEach((ele) => {
        ele.addEventListener("click", (event) => {
          event.stopImmediatePropagation();
          this._updateSubscriptionFrq(event);
        });
      });
    //Bind Click Event on Pause subscription Date
    document.querySelectorAll('[name="pause_subscription"]').forEach((ele) => {
      ele.addEventListener("click", (event) => {
        event.stopImmediatePropagation();
        let next_date = moment(
          subscriptionData.next_charge_scheduled_at
        ).format("MMMM DD, YYYY");
        if (ele.checked) {
          let pauseDate = moment(next_date).add(parseInt(ele.value), "M");

          ele
            .closest("[data-updated-next-charge-date]")
            .setAttribute(
              "data-updated-next-charge-date",
              pauseDate.format("YYYY-MM-DD")
            );
          ele
            .closest("[data-charge-frequency]")
            .setAttribute("data-charge-frequency", ele.value);
        }
      });
    });

    // Bind Click Event on Updating Charge Date Button
    document.querySelectorAll("[data-update_charge_date]").forEach((ele) => {
      ele.addEventListener("click", (event) => {
        event.stopImmediatePropagation();
        this._updateChargeDate(event);
      });
    });
    // Bind Click Event on Change Subscription Modal
    document
      .querySelectorAll("[data-update_subscription_btn]")
      .forEach((ele) => {
        ele.addEventListener("click", (event) => {
          event.stopImmediatePropagation();
          this._update_shirt(event);
        });
      });

    // Bind Click Event on Change Addon edit Modal
    document.querySelectorAll("[data-update_addon_btn]").forEach((ele) => {
      ele.addEventListener("click", (event) => {
        event.stopImmediatePropagation();
        this._editAddon(event);
      });
    });

    document.querySelectorAll("[add-addon]").forEach((ele) => {
      ele.addEventListener("click", (event) => {
        event.stopImmediatePropagation();

        let parent_ele = event.currentTarget.closest("[data-edit-card]");
        let qty = parent_ele.querySelector("[data-qty-input]").value;
        let var_id = event.currentTarget.getAttribute("data-addon_option");
        event.target.closest("[add-addon]")?.classList.add("loading");

        this._createaddonObj(qty, var_id);
        this._removeDisabledButton();
      });
    });

    // Bind Click Event on Cancel Subscription Modal
    document.querySelectorAll("[data-cancel_subscriptions]").forEach((ele) => {
      ele.addEventListener("click", (event) => {
        event.stopImmediatePropagation();
        event.currentTarget.classList.add("loading");
        let reason = document.querySelector(
          "[data-cancel-subscription-reason-select]"
        )?.value;
        let feedback = document.querySelector(
          "[data-cancel-subscription-reason-text]"
        )?.value;

        successModalType = "cancel-subscription";
        this._cancelSubscription(subscriptionData.id, reason, feedback);
      });
    });

    // Bind Click Event on Send em email Notification
    document
      .querySelector("[data-send_email]")
      ?.addEventListener("click", (event) => {
        event.target.closest("[data-send_email]")?.classList.add("loading");
        successModalType = "update-payment";
        this._updatePaymethodMethod();
        this._removeDisabledButton();
      });

    // Bind Click Event on Update Shipping Address Button
    document
      .querySelectorAll("[data-update_shipping_address]")
      .forEach((ele) => {
        ele.addEventListener("click", (event) => {
          event.stopImmediatePropagation();
          event.target
            .closest("[data-update_shipping_address]")
            ?.classList.add("loading");

          successModalType = "shipping-address";
          this._updateShippingAddress();
        });
      });

    // Bind delivery schedule
    document
      .querySelector("[data-delivery-link]")
      ?.addEventListener("click", () => {
        if (!scheduleDeliveryFlag) {
          document.querySelector(
            "[data-delivery_schedule]"
          ).innerHTML = `<div class="align-items-center bg-white d-flex h-100 justify-content-center position-absolute w-100" style="z-index: 5;opacity: 0.5;"><span class='spinner'></span></div>`;
          this.deliveryDetails();
          scheduleDeliveryFlag = true;
        }
      });

    // Bind click event when clicked on apply discount before cancel
    document
      .querySelector("[data-apply_discount_before_cancel]")
      ?.addEventListener("click", (event) => {
        event.stopImmediatePropagation();
        event.target
          .closest("[data-apply_discount_before_cancel]")
          ?.classList.add("loading");

        successModalType = "cancel-discount";
        this._applyDiscountBeforeCancel();
      });
  }

  async _applyDiscount(event) {
    event.currentTarget.classList.add("loading");
    let promocode = document.querySelector("[data-promocode]").value;

    if (promocode.length > 0) {
      event.target.closest("[data-update_addon_btn]")?.classList.add("loading");
      successModalType = "applied-promo";
      await this._applyDiscountToAddress(
        subscriptionData.address_id,
        promocode
      );
    } else {
      sdk.notification("Error", "Please enter promocode", "error");
    }
  }

  /**
   * Apply Discount Based on charge id
   *
   * @param {Number} charge_id
   * @param {Number} discount_id
   */
  async _applyDiscountToAddress(subscriptionAddressId, promocode) {
    let response = await sdk.applyDiscountToAddress(
      subscriptionAddressId,
      promocode
    );
    if (response) {
      this.onLoadData();
    } else {
      successModalType = null;
      document.querySelector(".btn.loading")?.classList.remove("loading");
      this.onLoadData();
    }
  }

  /**
   * Fetch Discounts
   */
  async _getDiscount() {
    discounts = await sdk._getDiscounts();
    let rechargeDiscounts = {};
    discounts.map((discount) => {
      rechargeDiscounts[discount.code.toLowerCase()] = discount;
    });
    discounts = rechargeDiscounts;
  }

  /**
   * Generate HTML for variant selector
   */
  _generateVariantSelectorHTML(addonProductJSON, currentSubsVariant) {
    let allProductOptions = "";
    for (const [, option] of addonProductJSON.entries()) {
      let optionHtml = ``;
      let title = currentSubsVariant.title.split("/");

      for (const value of option.values) {
        //to keep option selected
        let selectedClass = "";
        title.filter((t) => {
          if (t.trim() == value.trim()) {
            selectedClass = "selected";
          }
        });

        let temp = `<option value="${value}" ${selectedClass}>${value}</option>`;
        optionHtml += temp;
      }
      let tempHtml = `
                <div class="col-md-4 col-6  pe-2 ${
                  option.name.toLowerCase() == "title" ? "d-none" : ""
                }">
                    <h6 class="text-uppercase font-size-xs ls-2" >${
                      option.name
                    }:</h6>
                    <select name="pdp-${option.name}" id="pdp-${
        option.name
      }" data-product_option>
                        ${optionHtml}
                    </select>
                </div>
            `;
      allProductOptions += tempHtml;
    }
    document.querySelector(
      "[data-addon-onetime-subs-update] [data-subscription_options]"
    ).innerHTML = allProductOptions;
  }

  /**
   * Function to update variant price
   */
  _priceUpdate(currentSubsVariant) {
    let qty = document.querySelector(
      "[data-addon-onetime-subs-update] [data-quantity_parent] [data-qty-container] [data-qty-input]"
    ).value;
    let price = currentSubsVariant.price;
    price = `${Shopify.formatMoney(
      price * qty,
      window.globalVariables.money_format
    )}`;
    document.querySelector(
      "[data-onetime-div] [data-addon-onetime-price]"
    ).innerHTML = price;
  }

  /**
   * Function to decide which modal to show (cancel/apply discount before cancel)
   */
  _checkIfFirstTimeCancelled() {
    // Logic to show modal of cancel or discount
    let discountShowStatus = document
      .querySelector("[data-cancel_trigger]")
      .getAttribute("data-show_discount");
    // if(discountShowStatus == 'true') {
    //     let cancellation_status = subscriptionData.properties.find( x => x.name === "is_cancel_firsttime") || null ;
    //     // check if it has properties (which means that its not first time)
    //     if(cancellation_status == null) {
    //         // this means that its first time - show apply discount modal
    //         document.querySelectorAll('.modal.open').forEach(modal => {
    //             modal.classList.remove('open')
    //         });
    //         document.querySelector(`#cancelsub-discount-modal`).show();
    //     } else {
    //         // this means that its not first time, show cancel modal
    //         this._showCancelModal();
    //     }

    // } else {
    //     // this means that its not first time - show cancel modal
    //     this._showCancelModal();
    // }

    document.querySelector(`#cancelsub-discount-modal`).show();
  }

  /**
   * Function to populate addon modal
   */
  _populateAddonModal(addonProductJSON) {
    let price;
    let img;
    // get variant data - price, image
    addonProductJSON.variants.forEach((variant) => {
      if (currentSubsVariant.id == variant.id) {
        price = variant.price;
        if (variant.featured_image == null)
          img = addonProductJSON.featured_image;
        else img = variant.featured_image.src;
      }
    });
    let priceOnetime = Shopify.formatMoney(
      price,
      window.globalVariables.money_format
    );
    document.querySelector("[data-addon-product-img]").src = img;
    document.querySelector("[data-addon-product-title]").innerHTML =
      addonProductJSON.title;
    document.querySelector("[data-addon-onetime-price]").innerHTML =
      priceOnetime;
  }

  /**
   * Function to show cancel modal
   */
  _showCancelModal() {
    document.querySelectorAll(".modal.open").forEach((modal) => {
      modal.classList.remove("open");
    });
    this._resetCancelModalFeedback();
    document.querySelector(`#cancelsub-modal`).show();
  }

  /**
   * Function to apply discount before cancellation
   */

  async _applyDiscountBeforeCancel() {
    // Get discount value from theme settings
    let discountpercent = document
      .querySelector("[data-apply_discount_before_cancel]")
      .getAttribute("data-discount_amount");

    // Update the price with applying discount
    let subscriptionPrice = subscriptionData.price;
    let updatedPrice = (
      subscriptionPrice -
      (discountpercent * subscriptionPrice) / 100
    ).toFixed(2);

    let subscriptionProperties = subscriptionData.properties;
    // Append new value to properties array
    subscriptionProperties.push({
      name: "is_cancel_firsttime",
      value: "false",
    });

    let updatedSubscriptionObj = {
      price: updatedPrice,
      properties: subscriptionProperties,
    };
    await this._updateSubscription(subscriptionData.id, updatedSubscriptionObj);
  }

  /**
   *
   * @param {String} eventType : Performing specified action on specified event type modal
   * @param {element} element
   */
  async _showCurrentSubscription(event, eventType, element) {
    if (element.closest("[data-onetime-id]")) {
      // Set data when edit onetime
      currentAddon = element
        .closest("[data-onetime-id]")
        .getAttribute("data-onetime-id");
      let subscriptions = window.customerDetails.rechargeOnetimes.filter(
        (addon) => {
          if (addon.id == currentAddon) {
            return graphQLProductsJSON[addon.external_product_id.ecommerce];
          }
        }
      );

      if (subscriptions.length > 0) {
        subscriptionData = subscriptions[0];
      }
    } else if (element.closest("[data-subscription-id]")) {
      // Stores the current subscription data when any modal is opened
      let subscriptionId = parseInt(
        element
          .closest("[data-subscription-id]")
          ?.getAttribute("data-subscription-id")
      );
      let subscriptions = activeSubscriptions.filter((subscription) => {
        if (subscriptionId == subscription.id) {
          return subscription;
        }
      });
      if (subscriptions.length > 0) {
        subscriptionData = subscriptions[0];
      }
    }

    if (subscriptionData.id != undefined) {
      // Get Shopify Product JSON of Current Subscription Product
      if (productsJson[subscriptionData.external_product_id?.ecommerce]) {
        selectedProduct =
          productsJson[subscriptionData.external_product_id?.ecommerce];
      } else {
        //Display loader in popup before HTML structure is created
        document.querySelectorAll("[data-loader_popup]").forEach((loader) => {
          loader.classList.remove("d-none");
        });
        selectedProduct =
          graphQLProductsJSON[subscriptionData.external_product_id?.ecommerce];
        productsJson[selectedProduct.id] = selectedProduct;
      }

      selectedAddons = [];
      // Create addon array connected with subscription
      window.customerDetails.rechargeOnetimes.map((addon) => {
        addon.properties.map((prop) => {
          if (
            prop.name == "connected_subscription_id" &&
            prop.value == subscriptionData.id
          ) {
            selectedAddons.push(addon);
          }
        });
      });
      // Fetch Cancellation Reasons from Recharge admin side for cancellation modal
      if (storeCancellationReason.length == 0) {
        this._fetchCancellationReason();
      }
    }
    // Highlight Frequency Of Current Subscription
    if (eventType === "deliveryfrequency-modal") {
      this._createDeliveryFrequencyHTML();
      document.querySelectorAll("[data-subscription-frq]").forEach((ele) => {
        if (ele.querySelector("[data-subscription-frq-unit]") != null) {
          ele.querySelector("[data-subscription-frq-unit]").innerText =
            subscriptionData?.order_interval_unit;
        }
      });
      document
        .querySelector(
          `[data-subscription-frq="${subscriptionData.order_interval_frequency}"] label`
        )
        ?.click();
    }

    // Actions on Skipping Modal
    if (eventType === "skipnextshipment-modal") {
      document.querySelectorAll("[data-pause-checkbox]").forEach((ele) => {
        if (ele.checked == true) {
          ele.checked = false;
        }
      });
      document.querySelectorAll("[data-update_charge_date]").forEach((ele) => {
        ele.classList.add("d-none");
      });

      if (
        event.target
          .closest("[data-default_open]")
          .getAttribute("data-default_open") === "pause"
      ) {
        if (document.querySelector("#order-pause-subscription") != null) {
          document.querySelector("#order-pause-subscription").click();
        }
      } else {
        if (document.querySelector("#order-skip-next") != null) {
          document.querySelector("#order-skip-next").click();
        }
      }
    }

    // Actions on update subscription modal
    if (
      eventType === "changesubscription-modal" ||
      eventType === "editaddon-modal"
    ) {
      if (subscriptionData) {
        document
          .querySelectorAll("[data-update_subscription_btn]")
          .forEach((ele) => {
            ele.classList.add("d-none");
          });
        this._generateProductHtml(eventType);
      }
    }

    // Action on Edit Shipping Address Modal
    if (eventType === "shippingaddress-modal") {
      new Shopify.CountryProvinceSelector(
        "shipping_country",
        "shipping_province",
        {
          hideElement: "shippingProvinceContainer",
        }
      );
      this._fillShippingAddress(subscriptionData.address_id);
    } else if (eventType === "editsubscription-modal") {
      isProOpen = false;
      // Reset Frequency Model
      this._resetChangeFrequencyPopupDisplay();
      const change_frequency_model_btn = document.querySelector('[data-modal-opener="changefrequency-modal"]')
      const udm_model_btn = document.querySelector('[data-modal-opener="upgrade-downgrade-modal"]')

      if (subscriptionData.is_prepaid == true) {
        document.querySelector("[data-swap-modal]")?.classList?.add("d-none");
        change_frequency_model_btn?.classList?.add("d-none");
        udm_model_btn?.classList?.add("d-none");
      } else {
        document
          .querySelector("[data-swap-modal]")
          ?.classList?.remove("d-none");
          change_frequency_model_btn?.classList?.remove("d-none");
          udm_model_btn?.classList?.remove("d-none");
      }

      let isPause = false;
      // get properties
      for (let item of subscriptionData.properties) {
        if (item["name"] == "isPause") {
          isPause = `${item["value"]}`;
        }
      }
      if (isPause == false || isPause == "false") {
        document
          .querySelector("[data-skip-pause-wrap]")
          .classList.remove("d-none");
        document.querySelector("[data-resume-box]").classList.add("d-none");
      } else {
        document
          .querySelector("[data-skip-pause-wrap]")
          .classList.add("d-none");
        document.querySelector("[data-resume-box]").classList.remove("d-none");
      }
    } else if (eventType == "edit-product-popup") {
      let productType;
      let isPropertyExist = false;
      for (let item of subscriptionData.properties) {
        if (item["name"] == "product_type") {
          productType = item.value;
          isPropertyExist = true;
        }
      }
      if (isProOpen == true) {
        // document.querySelectorAll("[data-product-type]").forEach((ele) => {
        //   let type = ele.getAttribute("data-product-type");
        //   if (ele.closest("[data-swap-wrap]") != null) {
        //     if (type == "platecrate-pro") {
        //       ele.closest("[data-swap-wrap]").classList.remove("d-none");
        //     } else {
        //       ele.closest("[data-swap-wrap]").classList.add("d-none");
        //     }
        //   }
        // });
      } else if (isPropertyExist === false) {
        document.querySelectorAll("[data-product-type]").forEach((ele) => {
          let type = ele.getAttribute("data-product-type");
          if (ele.closest("[data-swap-wrap]") != null) {
            if (type == "platecrate-pro") {
              ele.closest("[data-swap-wrap]").classList.remove("d-none");
            } else {
              ele.closest("[data-swap-wrap]").classList.add("d-none");
            }
            if (
              ele
                .closest("[data-swap-wrap]")
                .querySelector("[main_product_id]")
                .getAttribute("main_product_id") ==
              subscriptionData.external_product_id.ecommerce
            ) {
              ele.closest("[data-swap-wrap]").classList.add("d-none");
            }
          }
        });
      } else {
        document.querySelectorAll("[data-product-type]").forEach((ele) => {
          let type = ele.getAttribute("data-product-type");
          if (ele.closest("[data-swap-wrap]") != null) {
            if (type == productType) {
              ele.closest("[data-swap-wrap]").classList.remove("d-none");
            } else {
              ele.closest("[data-swap-wrap]").classList.add("d-none");
            }
            if (
              ele
                .closest("[data-swap-wrap]")
                .querySelector("[main_product_id]")
                .getAttribute("main_product_id") ==
              subscriptionData.external_product_id.ecommerce
            ) {
              ele.closest("[data-swap-wrap]").classList.add("d-none");
            }
          }
        });
      }
      document.querySelectorAll("[data-pay-checkobox]").forEach((checkbox) => {
        if (checkbox.checked) {
          checkbox.checked = false;
        }
      });
      document
        .querySelectorAll("[data-swap_subscription_btn]")
        .forEach((ele) => {
          ele.classList.add("d-none");
        });
    }

    if (eventType === "resume-modal" && subscriptionData?.id != null) {
      this._resetResumeDatePickerState();
      this._applyResumeDateConstraints();
    }
  }

  _fillShippingAddress(address_id) {
    const regionNames = new Intl.DisplayNames(["en"], { type: "region" });
    document.querySelectorAll("[data-shipping_address]").forEach((ele) => {
      if (ele.getAttribute("data-shipping_address") != "country_code") {
        ele.value =
          customerAddresses[address_id][
            ele.getAttribute("data-shipping_address")
          ];
      }
      if (ele.getAttribute("data-shipping_address") == "country_code") {
        ele.value = regionNames.of(
          customerAddresses[address_id][
            ele.getAttribute("data-shipping_address")
          ]
        );
      }

      if (ele.hasAttribute("data-state")) {
        ele.value = customerAddresses[address_id].province;
        ele.dispatchEvent(new Event("change"));
      }
    });
  }

  _createDeliveryFrequencyHTML() {
    let html = ``;
    for (const selling_plan of selectedProduct.selling_plan_groups[0]
      .selling_plans) {
      let frq = "";
      if (selling_plan.options[0].value.toLowerCase().includes(" ")) {
        frq = selling_plan.options[0].value.split(" ")[0];
      }
      let tempHTML = `
            <div class="col-12 col-md-6 p-2" data-subscription-frq="${frq}">
                <div class="frequency-box h-100" >
                    <input type="radio" id="frequency-${frq}" name="frequency" value="${frq}" class="d-none">
                    <label class="mb-0 d-flex align-items-center justify-content-center" role="button"  tabindex="0" for="frequency-${frq}">
                        <div class="checkmark-icon d-flex">
                            <svg width="17" height="17" viewBox="0 0 17 17">
                                <path id="Icon_ionic-ios-checkmark-circle" data-name="Icon ionic-ios-checkmark-circle" d="M11.875,3.375a8.5,8.5,0,1,0,8.5,8.5A8.5,8.5,0,0,0,11.875,3.375Zm4.352,6.15-5.464,5.488h0a.738.738,0,0,1-.474.225.715.715,0,0,1-.478-.233L7.519,12.717a.163.163,0,0,1,0-.233l.727-.727a.158.158,0,0,1,.229,0l1.814,1.814,4.986-5.022a.161.161,0,0,1,.114-.049h0a.148.148,0,0,1,.114.049l.715.74A.161.161,0,0,1,16.227,9.525Z" transform="translate(-3.375 -3.375)" fill="#f36a10"/>
                            </svg>
                        </div>
                        <p class="mb-0 font-size-md fw-medium text-center text-capitalize"> every ${frq} <span data-subscription-frq-unit></span></p>
                    </label>
                </div>
            </div>
            `;
      html += tempHTML;
    }
    document.querySelector("[data-subscription_frequencies]").innerHTML = html;
  }

  /** Reset cancel modal feedback + confirm button state. */
  _resetCancelModalFeedback() {
    const root = document.querySelector("#cancelsub-modal");
    const reasonSelect = root?.querySelector(
      "[data-cancel-subscription-reason-select]"
    );
    const feedbackWrap = root?.querySelector("[data-cancel-feedback]");
    const feedbackText = root?.querySelector(
      "[data-cancel-subscription-reason-text]"
    );
    const cancelBtn = root?.querySelector("[data-cancel_subscriptions]");
    if (reasonSelect) {
      reasonSelect.selectedIndex = 0;
    }
    if (feedbackText) {
      feedbackText.value = "";
      feedbackText.removeAttribute("required");
    }
    if (feedbackWrap) {
      feedbackWrap.classList.add("d-none");
    }
    if (cancelBtn) {
      cancelBtn.classList.add("d-none");
      cancelBtn.classList.remove("disabled");
    }
  }

  _onCancelSubscriptionReasonChange(event) {
    const elememt = event.currentTarget;
    const root = document.querySelector("#cancelsub-modal");
    const feedbackWrap = root?.querySelector("[data-cancel-feedback]");
    const feedbackText = root?.querySelector(
      "[data-cancel-subscription-reason-text]"
    );
    const cancelBtn = root?.querySelector("[data-cancel_subscriptions]");
    if (elememt.value == "Other reason") {
      feedbackWrap?.classList.remove("d-none");
      feedbackText?.setAttribute("required", "required");
    } else {
      feedbackWrap?.classList.add("d-none");
      if (feedbackText) {
        feedbackText.value = "";
        feedbackText.removeAttribute("required");
      }
    }
    if (cancelBtn) {
      cancelBtn.classList.remove("d-none", "disabled");
    }
  }

  /**
   * Fetch Cancellation Reason and Render Reasons in Cancellation Modal
   */
  async _fetchCancellationReason() {
    // if(sessionStorage.getItem("retention_strategies") == null || sessionStorage.getItem("retention_strategies") == "null"){
    // let response = await sdk.getCancelReason();
    // sessionStorage.setItem("retention_strategies", JSON.stringify(response));
    // }
    try {
      let retention_response = await sdk.getCancelReason();

      let options = "";
      retention_response.retention_strategies
        .reverse()
        .forEach((retention_strategie) => {
          options += `<option  data-incentive-type="${retention_strategie.incentive_type}" data-incentive-message="${retention_strategie.prevention_text}" value="${retention_strategie.reason}">${retention_strategie.reason}</option>`;
        });

      let selectReasonBox = `
        <select name="reason" aria-label="reason" id="cancel_reason" class="form-control mb-1 select__size" placeholder="Select a reason" required data-cancel-subscription-reason-select>
            <option value="null" selected="selected" disabled="disabled">Select a reason</option>
            ${options}
        </select>`;

      document.querySelector(
        "#cancelsub-modal [data-cancel-reason]"
      ).innerHTML = selectReasonBox;

      this._resetCancelModalFeedback();
    } catch (error) {
      Rollbar.error(
        `Error in Cancellation reason function: ${error} , Customer: ${
          customerDetails.email
        }`
      );
    }
  }

  /**
   *  Generate current subscription shopify products options and price and Qty modal
   */
  _generateProductHtml(eventType) {
    selectedVariant = selectedProduct.variants.filter((item) => {
      if (
        item.external_variant_id ==
        subscriptionData.external_variant_id.ecommerce
      ) {
        return item;
      }
    });

    selectedVariant = selectedVariant[0];
    selectedAddonVariant = selectedVariant.external_variant_id;
    if (eventType == "editaddon-modal") {
      document.querySelector(
        "[data-update_subscription] [data-qty-input]"
      ).value = subscriptionData.quantity;
    } else {
      document.querySelector(
        "[data-subscription-update] [data-qty-input]"
      ).value = subscriptionData.quantity;
    }

    // Generate available options HTML for changing option
    let optionHtml = "";
    let default_var = false;
    for (const value of selectedProduct.variants) {
      let selectedClass = "";
      if (value.title == "Default Title") {
        default_var = true;
      } else {
        if (
          value.external_variant_id ==
          subscriptionData.external_variant_id.ecommerce
        ) {
          selectedClass = "selected";
        }
      }
      let temp = `<option value="${value.title}" ${selectedClass} data-id="${value.external_variant_id}">${value.title}</option>`;
      optionHtml += temp;
    }
    let allProductOptions = `
            <select name="pdp-size" id="pdp-size" class="form-select select__size ${
              default_var ? "d-none" : ""
            }" data-product_option>
                ${optionHtml}
            </select>
        `;

    // for edit addon html
    if (eventType === "editaddon-modal") {
      document.querySelector(
        `#${eventType} [data-addon-update] [data-subscription_options]`
      ).innerHTML = allProductOptions;
    } else {
      document.querySelector(
        "[data-subscription-update] [data-subscription_options]"
      ).innerHTML = allProductOptions;
    }

    // Bind Increment / Decrement Qty wrapper events
    document.querySelectorAll("[data-qty-btn]").forEach((ele) => {
      ele.addEventListener("click", (event) => {
        event.stopImmediatePropagation();
        let action = ele.getAttribute("data-qty-btn");
        let qty = parseInt(
          event.target.closest("[data-qty-container]").querySelector("input")
            .value
        );
        if (action === "plus") {
          event.target
            .closest("[data-qty-container]")
            .querySelector("input").value = qty + 1;
        } else {
          if (qty > 1) {
            event.target
              .closest("[data-qty-container]")
              .querySelector("input").value = qty - 1;
          }
        }
        let eventType = event.target.closest("modal-dialog").getAttribute("id");
        this._updateDataOnVariantChange(eventType);
      });
    });

    // Set variant on option changing
    document.querySelectorAll("[data-product_option]").forEach((ele) => {
      ele.addEventListener("change", (event) => {
        event.stopImmediatePropagation();
        let productOptions = [];
        document.querySelectorAll("[data-product_option]").forEach((ele) => {
          productOptions.push(ele.value);
        });
        let opt = event.currentTarget.value;
        if (opt == subscriptionData.variant_title) {
          document
            .querySelectorAll("[data-update_subscription_btn]")
            .forEach((ele) => {
              ele.classList.add("d-none");
            });
        } else {
          document
            .querySelectorAll("[data-update_subscription_btn]")
            .forEach((ele) => {
              ele.classList.remove("d-none");
            });
        }

        let variantsArray = selectedProduct.variants;
        selectedVariant = variantsArray.filter((variant) => {
          if (variant.title == productOptions[0]) {
            return variant;
          }
        });
        selectedVariant = selectedVariant[0];
        selectedAddonVariant = selectedVariant;
        this._updateDataOnVariantChange(eventType);
      });
    });

    // Update selectedVariant object and variant's price and image on changing options
    this._updateDataOnVariantChange(eventType);

    document.querySelectorAll("[data-loader_popup]").forEach((loader) => {
      loader.classList.add("d-none");
    });
  }

  /**
   * Update variant image and price on variant changed
   */
  _updateDataOnVariantChange(eventType) {
    let imgSrc = null;
    if (selectedVariant.image) {
      imgSrc = selectedVariant.image.src;
    } else if (selectedProduct.images) {
      imgSrc = selectedProduct.images;
    } else {
      imgSrc = window.customerDetails.no_image_replacement;
    }

    if (eventType === "editaddon-modal") {
      document
        .querySelector(
          `#${eventType} [data-addon-update] [data-update_subscription] [data-update_subscription_img]`
        )
        .setAttribute("src", imgSrc);
      this._priceChange(eventType);
    }
  }

  _priceChange(eventType) {
    let discountedPrice = selectedVariant.prices[0].unit_price * 100;
    let qty = document.querySelector(
      `#${eventType} [data-addon-update] [data-qty-container] [data-qty-input]`
    ).value;

    let price = `${Shopify.formatMoney(
      discountedPrice * qty,
      window.globalVariables.money_format
    )}`;
    document.querySelector(
      `#${eventType} [data-addon-update] [data-subscription_price]`
    ).innerHTML = price;
  }

  /**
   * Update variant on option changed
   */
  _updateVariant(variantsArray, productOptions) {
    let updatedVariant = variantsArray[0];
    variantsArray.find((variant) => {
      // get true or false based on options value presented in variant
      // value format would be [true/false,true/false,true/false] boolean value based on options present or not
      let variant_options = [];
      for (let i = 1; i <= 3; i++) {
        if (variant[`option${i}`] != null) {
          variant_options.push(variant[`option${i}`]);
        }
      }
      let mappedValues = variant_options.map((option, index) => {
        return productOptions[index] === option;
      });

      // assign variant details to this.currentVariant if all options are present
      if (!mappedValues.includes(false)) {
        updatedVariant = variant;
      }
    });
    return updatedVariant;
  }
  /**
   * Swap Subscription Function and prepare object for Updating subscription
   */
  async _swapSubscription(event) {
    let qty = document.querySelector(
      "[data-subscription-update] [data-qty-input]"
    ).value;
    let updateSubscriptionObj = {
      use_shopify_variant_defaults: true,
      external_variant_id: {
        ecommerce: `${selectedVariant.external_variant_id.toString()}`,
      },
      quantity: qty,
    };
    event.target
      .closest("[data-update_subscription_btn]")
      ?.classList.add("loading");
    successModalType = "plan-change";
    await this._updateSubscription(subscriptionData.id, updateSubscriptionObj);
  }

  async _update_shirt(event) {
    successModalType = "update_shirt_size";
    event.target
      .closest("[data-update_subscription_btn]")
      ?.classList.add("loading");
    let qty = document.querySelector(
      "[data-subscription-update] [data-qty-input]"
    ).value;
    subscriptionData.properties.forEach((sub_property) => {
      if (sub_property["name"] === "Free Tshirt" || sub_property["name"] === "Shirt Size") {
        sub_property["value"] = selectedVariant.title;
      }
    });
    document.querySelector("[updated_shirt_size]").innerHTML =
      selectedVariant.title;
    let data = {
      subscription_id: subscriptionData.id,
      shopify_variant_id: `${selectedVariant.external_variant_id.toString()}`,
      quantity: qty,
      properties: subscriptionData.properties,
    };

    let upcomingOrder = [];
    let allUpcomingOrders = await sdk._getUpcomingOrders();

    allUpcomingOrders.forEach((order) => {
      if (order.address_id == subscriptionData.address_id) {
        order.line_items.forEach((item) => {
          item.external_variant_id[
            "ecommerce"
          ] = `${selectedVariant.external_variant_id}`;
          item.properties.forEach((sub_property) => {
            if (sub_property["name"] == "Free Tshirt" || sub_property["name"] == "Shirt Size") {
              sub_property["value"] = selectedVariant.title;
            }
          });
          item.variant_title = selectedVariant.title;
          item.sku = selectedVariant.sku;
          delete item.external_inventory_policy;
          delete item.images;
          delete item.original_price;
        });
        let orderObj = {
          order_id: order.id.toString(),
          line_items: order.line_items,
        };
        upcomingOrder.push(orderObj);
      }
    });
    let response = await sdk._update_shirt(data);
    if (response) {
      if (subscriptionData.is_prepaid) {
        var order_response = await sdk.update_incomingOrder(upcomingOrder);
        if (order_response) {
          successModalType = "update_shirt_size";

          this.onLoadData();
        }
      } else {
        this.onLoadData();
      }
    }
  }

  /**
   * Swap Subscription Function with exchange of product and prepare object for Updating subscription
   */
  async _swapSubscriptionProduct() {
    let updateSubscriptionObj = {
      use_shopify_variant_defaults: true,
      external_variant_id: {
        ecommerce: `${selectedVariant.toString()}`,
      },
      external_product_id: {
        ecommerce: `${selectedProduct.toString()}`,
      },
    };
    successModalType = "plan-change";
    await this._updateSubscription(subscriptionData.id, updateSubscriptionObj);
  }

  /**
   * Edit Addon function
   */
  async _editAddon(event) {
    let qty = document.querySelector(
      "#editaddon-modal [data-addon-update] [data-qty-container] [data-qty-input]"
    ).value;
    let addonObj = {
      external_variant_id: {
        ecommerce: `${selectedVariant.external_variant_id.toString()}`,
      },
      quantity: qty,
    };
    event.target.closest("[data-update_addon_btn]")?.classList.add("loading");
    successModalType = "update-addon";
    await this._updateOnetimeAddon(currentAddon, addonObj);
  }

  /**
   * Open Confirmation Modal Dialog
   */
  _showSuccessModal() {
    document.querySelectorAll(".modal.open").forEach((modal) => {
      modal.classList.remove("open");
    });
    this._hideElement("[data-success_message]");
    if (document.querySelector(`#${successModalType} .modal`) != null) {
      document.querySelector(`#${successModalType}`)?.show();
    } else {
      document.querySelector(`#all-confirmed-modal`)?.show();
      this._showElement(`[data-success_message="${successModalType}"]`);
    }
    successModalType = null;
  }

  /**
   * Update Subscription Frequency
   */
  async _updateSubscriptionFrq(event) {
    let frq = event.target
      .closest("#deliveryfrequency-modal")
      .querySelector("input:checked").value;
    let frq_unit = subscriptionData.order_interval_unit;
    let updateSubscriptionObj = {
      charge_interval_frequency: frq,
      order_interval_frequency: frq,
      order_interval_unit: frq_unit,
    };
    event.target
      .closest("[data-update-subscription_frq]")
      ?.classList.add("loading");

    successModalType = "-modal";
    await this._updateSubscription(subscriptionData.id, updateSubscriptionObj);
  }

  /**
   * Update Next Charge Date
   */
  async _updateChargeDate(event) {
    let currentEle = event.currentTarget;
    currentEle.classList.add("loading");

    let newChargeDate = event.target
      .closest("[data-updated-next-charge-date]")
      .getAttribute("data-updated-next-charge-date");
    let frequency = parseInt(
      event.target
        .closest("[data-charge-frequency]")
        .getAttribute("data-charge-frequency")
    );

    if (subscriptionData.is_prepaid == true) {
      await this._pausePrepaidSubscription(subscriptionData.id, frequency);
      this._pauseSubscription(subscriptionData.id, newChargeDate);
    } else {
      this._pauseSubscription(subscriptionData.id, newChargeDate);
    }

    document.querySelector("[data-successChargeDate_pause]").innerText =
      moment(newChargeDate).format("MMMM DD, YYYY");
  }

  async _resumeSubscription(event) {
    const minM = this._getMinResumeDateMoment();
    if (
      !resumeDate ||
      moment(resumeDate).startOf("day").isBefore(minM)
    ) {
      sdk.notification(
        "Invalid date",
        `Please choose a resume date on or after ${minM.format("MMMM D, YYYY")}.`,
        "error"
      );
      return;
    }

    const triggerEl =
      event?.currentTarget ||
      document.querySelector("#resume-modal [data-resume-btn]");
    if (!triggerEl?.classList) {
      return;
    }

    const clearLoading = () => triggerEl.classList.remove("loading");

    triggerEl.classList.add("loading");
    isResume = true;
    if (subscriptionData.is_prepaid == false) {
      let response = await sdk._changeChargeDate(
        subscriptionData.id,
        resumeDate
      );
      if (response) {
        successModalType = "resume";
        this.onLoadData();
      } else {
        clearLoading();
      }
    } else {
      let currentSubscriptionOrder = [];
      let allUpcomingOrders = await sdk._getUpcomingOrders();
      if (!Array.isArray(allUpcomingOrders)) {
        allUpcomingOrders = [];
      }
      let addressId = subscriptionData.address_id;
      let count = 1;
      let nextChargeDate;

      allUpcomingOrders.forEach((order) => {
        if (order.address_id == addressId) {
          if (count == 1) {
            let new_schedule_date = moment(resumeDate).format("YYYY-MM-DD");
            if (order.id != null) {
              let nextChanrgeObj = {
                order_id: order.id.toString(),
                new_schedule_date: new_schedule_date.toString(),
              };
              currentSubscriptionOrder.push(nextChanrgeObj);
            }
            count = count + 1;
          } else {
            let new_shedule_date = moment(resumeDate)
              .add(
                subscriptionData.order_interval_frequency,
                subscriptionData.order_interval_unit
              )
              .format("YYYY-MM-DD");
            if (order.id != null) {
              let nextChanrgeObj = {
                order_id: order.id.toString(),
                new_schedule_date: new_shedule_date.toString(),
              };
              currentSubscriptionOrder.push(nextChanrgeObj);
            }
            count = count + 1;
            resumeDate = new_shedule_date;
            nextChargeDate = moment(resumeDate)
              .add(
                subscriptionData.order_interval_frequency,
                subscriptionData.order_interval_unit
              )
              .format("YYYY-MM-DD");
          }
        }
      });

      if (nextChargeDate == null && resumeDate) {
        nextChargeDate = moment(resumeDate).format("YYYY-MM-DD");
      }

      const prepaidOk = await this.updateChargeDateForPrepaid(
        currentSubscriptionOrder
      );
      if (!prepaidOk) {
        clearLoading();
        return;
      }

      let response = await sdk._changeChargeDate(
        subscriptionData.id,
        nextChargeDate
      );
      if (response) {
        successModalType = "resume";
        this.onLoadData();
      } else {
        clearLoading();
      }
    }
  }

  async _pausePrepaidSubscription(subscriptionId, frequency) {
    let currentSubscriptionOrder = [];
    let allUpcomingOrders = await sdk._getUpcomingOrders();
    if (allUpcomingOrders.length > 0) {
      let addressId = subscriptionData.address_id;
      allUpcomingOrders.forEach((order) => {
        if (order.address_id == addressId) {
          let new_schedule_date = moment(order.scheduled_at)
            .add(frequency, subscriptionData.order_interval_unit)
            .format("YYYY-MM-DD");
          if (order.id != null) {
            let nextChanrgeObj = {
              order_id: order.id.toString(),
              new_schedule_date: new_schedule_date.toString(),
            };
            currentSubscriptionOrder.push(nextChanrgeObj);
          }
        }
      });
      this.updateChargeDateForPrepaid(currentSubscriptionOrder);
    }
  }

  async updateChargeDateForPrepaid(currentSubscriptionOrder) {
    if (
      !currentSubscriptionOrder ||
      currentSubscriptionOrder.length === 0
    ) {
      return true;
    }

    const orders = { orders: currentSubscriptionOrder };

    const response = await fetch(
      `/tools/platecrate-custom-api/update-order-next-charge-date`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(orders),
      }
    );

    if (response.ok) {
      return true;
    }

    try {
      const err = await response.json();
      const detail =
        (err.errors &&
          (Array.isArray(err.errors.orders)
            ? err.errors.orders.join(" ")
            : String(err.errors.orders || ""))) ||
        err.message ||
        "Could not update order dates.";
      sdk.notification("Update failed", detail, "error");
    } catch (e) {
      sdk.notification(
        "Update failed",
        "Could not update order dates.",
        "error"
      );
    }
    return false;
  }
  /**
   * Unskip subscription
   */
  async _unSkipChargeDate(subscriptionData, newChargeDate) {
    successModalType = "unskip";
    let updatedSubsObj = {
      charge_interval_frequency: subscriptionData.charge_interval_frequency,
      order_interval_unit: subscriptionData.order_interval_unit,
      order_interval_frequency: subscriptionData.order_interval_frequency,
      next_charge_scheduled_at: newChargeDate,
      properties: [{ name: "is_skipped", value: "false" }],
    };
    let response = await sdk._updateSubscription(
      subscriptionData.id,
      updatedSubsObj
    );
    if (response) {
      // If Addons are connected with subscription change their dates also
      if (selectedAddons.length > 0) {
        let response2 = await sdk._changeChargeDateAddon(
          selectedAddons,
          newChargeDate
        );
        if (response2) {
          this.onLoadData();
        }
      } else {
        this.onLoadData();
      }
    }
  }

  /**
   * Skip subscription
   */
  async _skipChargeDate(subscriptionData, newChargeDate) {
    successModalType = "skip";
    let updatedSubsObj = {
      charge_interval_frequency: subscriptionData.charge_interval_frequency,
      order_interval_unit: subscriptionData.order_interval_unit,
      order_interval_frequency: subscriptionData.order_interval_frequency,
      next_charge_scheduled_at: newChargeDate,
      properties: [{ name: "is_skipped", value: "true" }],
    };
    let response = await sdk._updateSubscription(
      subscriptionData.id,
      updatedSubsObj
    );
    if (response) {
      // If Addons are connected with subscription change their dates also
      if (selectedAddons.length > 0) {
        let response2 = await sdk._changeChargeDateAddon(
          selectedAddons,
          newChargeDate
        );
        if (response2) {
          this.onLoadData();
        }
      } else {
        this.onLoadData();
      }
    }
  }

  /**
   * Pause subscription
   */
  async _pauseSubscription(subscriptionId, newChargeDate) {
    successModalType = "pause";
    await this._setNextChargeDate(subscriptionId, newChargeDate);
  }

  /**
   * Update Shipping Address
   */
  async _updateShippingAddress() {
    let shippingAddressObj = {};
    document.querySelectorAll("[data-shipping_address]").forEach((ele) => {
      if (ele.getAttribute("data-shipping_address") != "country_code") {
        shippingAddressObj[ele.getAttribute("data-shipping_address")] =
          ele.value;
      }
    });
    successModalType = "shipping-address";
    await this._changeShippingAddress(
      subscriptionData.address_id || customerAddressId,
      shippingAddressObj
    );
  }

  /**
   * Create addon object
   */
  _createaddonObj(qty, var_id) {
    let variant_id = "";
    if (var_id) {
      variant_id = var_id;
    } else {
      variant_id = selectedVariant.external_variant_id;
    }
    let addonObj = {
      address_id: subscriptionData.address_id,
      next_charge_scheduled_at: subscriptionData.next_charge_scheduled_at,
      use_shopify_variant_defaults: true,
      external_variant_id: {
        ecommerce: `${variant_id}`,
      },
      quantity: qty,
      properties: [
        {
          name: "connected_subscription_id",
          value: `${subscriptionData.id}`,
        },
      ],
    };
    this._createOnetimeAddon(addonObj);
  }

  /**
   * Function to create subscription data object
   */
  _createSubscriptionObj(frequency, intervalUnit, qty) {
    let subsDataObj = {
      address_id: subscriptionData.address_id,
      next_charge_scheduled_at: subscriptionData.next_charge_scheduled_at,
      charge_interval_frequency: frequency,
      order_interval_frequency: frequency,
      order_interval_unit: intervalUnit,
      external_variant_id: {
        ecommerce: `${selectedVariant.external_variant_id.toString()}`,
      },
      quantity: qty,
      property: subscriptionData.properties,
    };
    this._createSubscriptionProduct(subsDataObj);
  }

  /**
   * remove d-none class
   * @param {*} elememt
   */
  _showElement = (elememt) => {
    document.querySelectorAll(elememt).forEach((ele) => {
      ele.classList.remove("d-none");
    });
  };

  /**
   * Add d-none class
   * @param {*} elememt
   */
  _hideElement = (elememt) => {
    document.querySelectorAll(elememt).forEach((ele) => {
      ele.classList.add("d-none");
    });
  };

  /**
   * Enable each button once any api call is completed
   */
  _removeDisabledButton() {
    document.querySelectorAll(".btn").forEach((ele) => {
      ele.classList.remove("disabled");
    });
  }

  // Functions for recharge dashboard updation - 15 Apr 2024

  // to change the data in swap popup as per the subscription type
  _handleSwapPopupData(subscriptionType) {
    document.querySelectorAll("[data-product-type]").forEach((ele) => {
      let type = ele.getAttribute("data-product-type");
      if (ele.closest("[data-swap-wrap]") != null) {
        if (type == subscriptionType) {
          ele.closest("[data-swap-wrap]").classList.remove("d-none");
        } else {
          ele.closest("[data-swap-wrap]").classList.add("d-none");
        }
      }
    });
  }

  //   ------------------Change Frequency Model--------------------------

  // Reset data on change frequency Popup
  _resetChangeFrequencyPopupDisplay() {
    // Hide Dropdown
    const dropdownList = document.getElementById(
      "cfm-change-frequency-dropdown"
    );
    dropdownList?.classList?.add("d-none");

    // Hide Save Btn

    const saveChangesBtn = document.getElementById("cfm-save-changes-btn");
    saveChangesBtn?.classList?.add("d-none");

    // Reset frequency radion Btn

    const shippingFreqButtons = document.querySelectorAll(
      "[data-cfm-ship-frequency]"
    );
    shippingFreqButtons?.forEach(function (radioButton) {
      radioButton.checked = false;
    });
  }

  //   _addCFMEventLister()
  _addEventListernToCFMPopupButtons() {
    // For Back Close Btns
    document
      .getElementById("cfm-back-btn")
      ?.addEventListener("click", this._resetChangeFrequencyPopupDisplay);

    // For Frequency Btns
    document.querySelectorAll("[data-cfm-ship-frequency]")?.forEach((btn) => {
      btn.addEventListener("change", this._updateCFMDropdown);
    });

    document
      .getElementById("cfm-change-frequency-dropdown")
      ?.addEventListener("change", (e) => {
        const saveChangesBtn = document.getElementById("cfm-save-changes-btn");
        saveChangesBtn.classList.remove("d-none");
        this._cfmSaveChangesHandler(e);
      });
  }

  // Update options of pay frequency when change shipping frequency on CFM
  _updateCFMDropdown(e) {
    const dropdownList = document.getElementById(
      "cfm-change-frequency-dropdown"
    );
    dropdownList.classList.remove("d-none");
    dropdownList[0].selected = true;
    const saveChangesBtn = document.getElementById("cfm-save-changes-btn");
    saveChangesBtn.classList.add("d-none");

    const shippingFreq = e.target.dataset.cfmShipFrequency;
    cfmShippingFrequency = shippingFreq;

    const productType = subscriptionData?.properties?.filter((prop) => {
      if (prop.name === "product_type") return prop;
    });

    document.querySelectorAll(".cfm-options").forEach((option) => {
      let optionShippingFreq = option.getAttribute(
        "data-cfm-option-shipping-frequency"
      );
      let optionSubsType = option.getAttribute(
        "data-cfm-option-subscription-type"
      );
      if (
        optionShippingFreq == shippingFreq &&
        optionSubsType == productType[0]?.value
      ) {
        option.classList.remove("d-none");
      } else {
        option.classList.add("d-none");
      }
    });
  }

  // Update CFM object when user selects pay frequency in CFM
  _cfmSaveChangesHandler(event) {
    let currentEle = event.currentTarget.selectedOptions[0];
    let payFrequency = parseInt(
      currentEle.getAttribute("data-cfm-option-pay-frequency")
    );
    let shipFrequency = parseInt(cfmShippingFrequency);
    let productType = currentEle.getAttribute(
      "data-cfm-option-subscription-type"
    );
    let mainProductData = JSON.parse(
      currentEle.querySelector("[data-cfm-main-product-variant]").innerText
    );
    mainProductData = mainProductData.find(
      (x) => x.variant_title == subscriptionData.variant_title
    );

    // subscription_varint_id is not compatible with new subscriptions
    // let variantId = parseInt(mainProductData.subscription_varint_id);

    let variantId = null;
    if(productType=="platecrate-lite"){
      variantId = parseInt(mainProductData.variant_id);
    } else{
      variantId = parseInt(mainProductData.subscription_varint_id);
    }

    cfmFrequencyObject = {
      payFrequency: payFrequency,
      shipFrequency: shipFrequency,
      productType: productType,
      variantId: variantId,
    };
  }

  // Update Frequency Function
  updateSubscriptionFrequency = async (event) => {
    let currentTarget = event.currentTarget;
    currentTarget.classList.add("loading");
    let flag = false;

    for (let item of subscriptionData.properties) {
      if (item["name"] === "product_type") {
        item["value"] = cfmFrequencyObject.productType;
        flag = true;
      }
    }
    if (flag == false) {
      let subscriptionproperty = {
        name: "product_type",
        value: cfmFrequencyObject.productType,
      };
      subscriptionData.properties.push(subscriptionproperty);
    }

    let subsDataObj = {
      address_id: subscriptionData.address_id,
      next_charge_scheduled_at: subscriptionData.next_charge_scheduled_at,
      charge_interval_frequency: cfmFrequencyObject.payFrequency,
      order_interval_frequency: cfmFrequencyObject.shipFrequency,
      order_interval_unit: subscriptionData.order_interval_unit,
      external_variant_id: {
        ecommerce: `${cfmFrequencyObject.variantId.toString()}`,
      },
      quantity: subscriptionData.quantity,
      properties: subscriptionData.properties,
    };
    let response = await sdk._createSubscriptionProduct(subsDataObj);
    await this._deleteCurrentSubscription();
    document.querySelector("[data-swap-text]").innerHTML = `
        Your subscription plan frequency has been updated. Your next subscription payment will be ${
          response.next_charge_scheduled_at != null
            ? moment(response.next_charge_scheduled_at).format("MMMM DD, YYYY")
            : this._checkChargeError(response)
        } and renews every ${
          response.charge_interval_frequency == 1 ? "month": `${response.charge_interval_frequency} months`
        } for $${response.price}.
        `;
   
    //   gtag("event", "PlateCrate_pro_upgrade", {
    //     email: customerDetails.email,
    //   });
    successModalType = "pro_upgraded";
    let totalCrate =
      response.charge_interval_frequency / response.order_interval_frequency;
    if (totalCrate == 1) {
      totalCrate = `${totalCrate} crate`;
    } else {
      totalCrate = `${totalCrate} crates`;
    }
    let chargeFre = response.charge_interval_frequency;
    if (chargeFre == 1) {
      chargeFre = `${chargeFre} month`;
    } else {
      chargeFre = `${chargeFre} months`;
    }
    let price = response.price.replace(".00", "");
    price = `$${price}`;
    document.querySelector(
      "[upgrade_pro_text]"
    ).innerHTML = `
    Your subscription plan frequency has been updated. Your next subscription payment will be ${
      response.next_charge_scheduled_at != null
        ? moment(response.next_charge_scheduled_at).format("MMMM DD, YYYY")
        : this._checkChargeError(response)
    } and renews every ${
  response.charge_interval_frequency == 1 ? "month": `${response.charge_interval_frequency} months`
} for $${response.price}.
    `;
  
    await this.onLoadData();
  };

  //   -----------------------------------------------------------------------

  //   ------------------Upgrade/Downgrade Model--------------------------

  // Reset UDM
  _resetUpgradeDowngradePopupDisplay() {
    // Hide Save Btn
    const saveChangesBtn = document.getElementById("udmSaveChangesBtn");
    saveChangesBtn.classList.add("d-none");

    // Reset frequency radion Btn
    const subscriptionsRadioButtons = document.querySelectorAll(
      "[data-ugm-radio-btn]"
    );

    const productType = subscriptionData?.properties?.filter((prop) => {
      if (prop.name === "product_type") return prop;
    });

    subscriptionsRadioButtons.forEach((btn) => {
      btn.checked = false;
      let subsTypeBtn = btn.getAttribute("data-ugm-radio-btn");
      if (productType[0]?.value == subsTypeBtn) {
        btn.disabled = true;
        btn.parentNode.style.pointerEvents = "none";
      } else {
        btn.disabled = false;
        btn.parentNode.style.pointerEvents = "auto";
      }

      btn.addEventListener("change", () => {
        let optionSubsType = btn.getAttribute("data-ugm-radio-btn");
        selectedUDMOption = optionSubsType;
        this._udmSaveChangeBtnHandler(subsTypeBtn);
      });
    });
  }

  // upgrade downgrade save change handler
  _udmSaveChangeBtnHandler(productType) {
    const saveChangesBtn = document.getElementById("udmSaveChangesBtn");

    const payFrequency = subscriptionData.charge_interval_frequency;
    const shippingFrequency = subscriptionData.order_interval_frequency;

    let findSubscriptionProduct = null;
    document.querySelectorAll(".cfm-options").forEach((option) => {
      let option_payFreq = option.getAttribute("data-cfm-option-pay-frequency");
      let option_shipFreq = option.getAttribute(
        "data-cfm-option-shipping-frequency"
      );
      let option_subType = option.getAttribute(
        "data-cfm-option-subscription-type"
      );

      if (
        option_payFreq == payFrequency &&
        option_shipFreq == shippingFrequency &&
        option_subType == selectedUDMOption
      )
        findSubscriptionProduct = option;
    });

    if (findSubscriptionProduct != null) {
      saveChangesBtn.classList.remove("d-none");

      let mainProductData = JSON.parse(
        findSubscriptionProduct.querySelector("[data-cfm-main-product-variant]")
          .innerText
      );
      mainProductData = mainProductData.find(
        (x) => x.variant_title == subscriptionData.variant_title
      );

      // subscription_varint_id is not compatible with new subscriptions

      let variantId = null;
      if(productType=="platecrate-lite"){
        variantId = parseInt(mainProductData.variant_id);
      } else{
        variantId = parseInt(mainProductData.subscription_varint_id);
      }
      
      upgradeDowngradeObject = {
        payFrequency: parseInt(payFrequency),
        shipFrequency: parseInt(shippingFrequency),
        productType: selectedUDMOption,
        variantId: variantId,
      };
    } else {
      saveChangesBtn.classList.add("d-none");
    }
  }

  // Upgrade and downgrade subscription handler
  async updateDowngradeSubscription(event) {
    let currentTarget = event.currentTarget;
    currentTarget.classList.add("loading");
    let flag = false;
    let prevSubscriptionType = ""
    let updatedSubscription = upgradeDowngradeObject.productType;
    for (let item of subscriptionData.properties) {
      if (item["name"] === "product_type") {
        prevSubscriptionType = item["value"]
        item["value"] = updatedSubscription;
        flag = true;
      }
    }
    if (flag == false) {
      let subscriptionproperty = {
        name: "product_type",
        value: updatedSubscription,
      };
      subscriptionData.properties.push(subscriptionproperty);
    }

    let subsDataObj = {
      address_id: subscriptionData.address_id,
      next_charge_scheduled_at: subscriptionData.next_charge_scheduled_at,
      charge_interval_frequency: upgradeDowngradeObject.payFrequency,
      order_interval_frequency: upgradeDowngradeObject.shipFrequency,
      order_interval_unit: subscriptionData.order_interval_unit,
      external_variant_id: {
        ecommerce: `${upgradeDowngradeObject.variantId.toString()}`,
      },
      quantity: subscriptionData.quantity,
      properties: subscriptionData.properties,
    };
    let response = await sdk._createSubscriptionProduct(subsDataObj);
 

    if(!response) return;
    await this._deleteCurrentSubscription();
    document.querySelector("[data-swap-text]").innerHTML = `Your subscription plan has been updated to from ${subscriptionTypes[prevSubscriptionType]} to ${subscriptionTypes[updatedSubscription]}.`;
      //   gtag("event", "PlateCrate_pro_upgrade", {
      //     email: customerDetails.email,
      //   });
      successModalType = "pro_upgraded";
      // let totalCrate =
      //   response.charge_interval_frequency / response.order_interval_frequency;
      // if (totalCrate == 1) {
      //   totalCrate = `${totalCrate} crate`;
      // } else {
      //   totalCrate = `${totalCrate} crates`;
      // }
      // let chargeFre = response.charge_interval_frequency;
      // if (chargeFre == 1) {
      //   chargeFre = `${chargeFre} month`;
      // } else {
      //   chargeFre = `${chargeFre} months`;
      // }
      // let price = response.price.replace(".00", "");
      // price = `$${price}`;
      document.querySelector(
        "[upgrade_pro_text]"
      ).innerHTML = `Your subscription plan has been updated to from ${subscriptionTypes[prevSubscriptionType]} to ${subscriptionTypes[updatedSubscription]}.`;
    

    await this.onLoadData();
  }
}
customElements.define("custom-dashboard", dashboard);
